/*
 * Restaurant Order Core - frontend.js
 * File Version: 1.118.0
 */
(function () {
  'use strict';

  var rocWinListeners = {};
  function rocAddWinListener(instanceId, type, fn, opts) {
    window.addEventListener(type, fn, opts);
    (rocWinListeners[instanceId] = rocWinListeners[instanceId] || []).push([type, fn, opts]);
  }
  function rocClearWinListeners(instanceId) {
    var list = rocWinListeners[instanceId] || [];
    for (var i = 0; i < list.length; i++) {
      try { window.removeEventListener(list[i][0], list[i][1], list[i][2]); } catch (e) {  }
    }
    rocWinListeners[instanceId] = [];
  }

  var ROCUtils = (typeof module !== 'undefined' && module.exports && typeof require === 'function')
    ? require('./frontend-utils.js')
    : ((typeof window !== 'undefined' && window.ROCFrontend) || {});
  var specialDayMode = ROCUtils.specialDayMode;
  var specialDayNote = ROCUtils.specialDayNote;
  var serviceAllowedOnDate = ROCUtils.serviceAllowedOnDate;
  var calendarDayState = ROCUtils.calendarDayState;

  var DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

  function money(value, currency) {
    return Number(value || 0).toFixed(2) + ' ' + (currency || 'CHF');
  }

  function el(tag, props, children) {
    var node = document.createElement(tag);
    if (props) {
      Object.keys(props).forEach(function (key) {
        var value = props[key];
        if (value == null || value === false) return;
        if (key === 'class') node.className = value;
        else if (key === 'text') node.textContent = value;
        else if (key === 'value') node.value = value;
        else if (key === 'rich') appendRichText(node, value);
        else if (key === 'disabled' || key === 'checked' || key === 'hidden' || key === 'required') node[key] = true;
        else node.setAttribute(key, value);
      });
    }
    if (children != null) {
      (Array.isArray(children) ? children : [children]).forEach(function (child) {
        if (child == null || child === false) return;
        node.appendChild(child instanceof Node ? child : document.createTextNode(String(child)));
      });
    }
    return node;
  }

  function icon(name) {
    return el('span', { 'class': 'roc__ico roc__ico--' + name, 'aria-hidden': 'true' });
  }

  function mergeAttrs(a, b) {
    var out = {}, k;
    for (k in a) { if (Object.prototype.hasOwnProperty.call(a, k)) { out[k] = a[k]; } }
    for (k in b) { if (Object.prototype.hasOwnProperty.call(b, k)) { out[k] = b[k]; } }
    return out;
  }

  function afterFirstPaint(fn) {
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(fn);
      });
    } else {
      window.setTimeout(fn, 0);
    }
  }

  function groupLegendNodes(name, required) {
    var star = required ? [el('span', { 'class': 'roc__mg-legend-star' }, [' *'])] : [];
    var sep = String(name).indexOf(' / ');
    if (sep === -1) {
      return [el('span', { 'class': 'roc__mg-legend-main' }, [name])].concat(star);
    }
    return [
      el('span', { 'class': 'roc__mg-legend-main' }, [String(name).slice(0, sep)]),
      el('span', { 'class': 'roc__mg-legend-alt' }, [String(name).slice(sep + 3)].concat(star))
    ];
  }

  function appendRichText(parent, html) {
    var ALLOWED = { STRONG: 1, EM: 1, BR: 1 };
    var parsed = new DOMParser().parseFromString(String(html == null ? '' : html), 'text/html');
    var body = parsed.body;
    if (!body) return;
    function emit(target, node) {
      if (node.nodeType === 3) {
        target.appendChild(document.createTextNode(node.nodeValue || ''));
        return;
      }
      if (node.nodeType !== 1) return;
      var tag = node.tagName;
      if (ALLOWED[tag]) {
        var clean = document.createElement(tag.toLowerCase());
        if (tag !== 'BR') {
          Array.prototype.slice.call(node.childNodes).forEach(function (child) { emit(clean, child); });
        }
        target.appendChild(clean);
      } else {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) { emit(target, child); });
      }
    }
    Array.prototype.slice.call(body.childNodes).forEach(function (node) { emit(parent, node); });
  }

  function t(settings, key, fallback) {
    var dict = (settings && settings.i18n) || {};
    return dict[key] || fallback;
  }

  function iconLabel(settings, slug) {
    var map = (((settings && settings.i18n) || {}).iconLabels) || {};
    if (map[slug]) return map[slug];
    var info = ((settings && settings.productIcons) || {})[slug];
    return (info && info.label) || '';
  }

  var ROC_ADDR_FOLD = {
    'ä': 'a', 'ö': 'o', 'ü': 'u', 'Ä': 'a', 'Ö': 'o', 'Ü': 'u',
    'à': 'a', 'á': 'a', 'â': 'a', 'ã': 'a', 'å': 'a', 'À': 'a', 'Á': 'a', 'Â': 'a',
    'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e', 'È': 'e', 'É': 'e', 'Ê': 'e', 'Ë': 'e',
    'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i', 'Î': 'i', 'Ï': 'i',
    'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'Ô': 'o',
    'ù': 'u', 'ú': 'u', 'û': 'u', 'Û': 'u', 'ç': 'c', 'Ç': 'c', 'ñ': 'n', 'Ñ': 'n'
  };

  function rocAddrNormalizeStreet(street) {
    var s = String(street == null ? '' : street);
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var ch = s.charAt(i);
      out += Object.prototype.hasOwnProperty.call(ROC_ADDR_FOLD, ch) ? ROC_ADDR_FOLD[ch] : ch;
    }
    return out.toLowerCase().replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  }

  function rocAddrParseHouseNumber(field) {
    var trimmed = String(field == null ? '' : field).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
    if (trimmed === '') return { street: '', number: '' };
    var parts = trimmed.split(' ');
    var last = parts[parts.length - 1];
    if (parts.length > 1 && /^\d/.test(last)) {
      parts.pop();
      return { street: parts.join(' ').replace(/^\s+|\s+$/g, ''), number: last };
    }

    var glued = last.match(/^(.*[^0-9\s])(\d{1,4}[a-zA-Z]?)$/);
    if (glued) {
      parts[parts.length - 1] = glued[1];
      return { street: parts.join(' ').replace(/^\s+|\s+$/g, ''), number: glued[2] };
    }
    return { street: trimmed, number: '' };
  }

  function rocAddrDecomposeNumber(number) {
    var n = String(number == null ? '' : number).toLowerCase().replace(/^\s+|\s+$/g, '');
    var m = n.match(/^(\d+)\s*([a-z]?)/);
    if (m) return { stem: m[1], suffix: m[2] || '' };
    return { stem: '', suffix: '' };
  }

  function rocAddrDbStems(value) {
    var v = String(value == null ? '' : value).toLowerCase().replace(/^\s+|\s+$/g, '');
    var range = v.match(/^(\d+)\s*[-\/]\s*(\d+)/);
    if (range) {
      var from = parseInt(range[1], 10);
      var to = parseInt(range[2], 10);
      if (to < from) { var tmp = from; from = to; to = tmp; }
      if (to - from > 200) to = from + 200;
      var stems = [];
      for (var i = from; i <= to; i++) stems.push(String(i));
      return stems;
    }
    var d = rocAddrDecomposeNumber(v);
    return d.stem === '' ? [] : [d.stem];
  }

  function rocAddrNumberMatches(queryNumber, dbNumbers) {
    var q = rocAddrDecomposeNumber(queryNumber);
    if (q.stem === '') return true;
    var hasAny = false;
    var list = dbNumbers || [];
    for (var i = 0; i < list.length; i++) {
      var stems = rocAddrDbStems(list[i]);
      if (stems.length) hasAny = true;
      if (stems.indexOf(q.stem) !== -1) return true;
    }
    return !hasAny;
  }

  function rocAddrLevenshtein(a, b) {
    a = String(a); b = String(b);
    var al = a.length, bl = b.length;
    if (al === 0) return bl;
    if (bl === 0) return al;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= bl; j++) prev[j] = j;
    for (i = 1; i <= al; i++) {
      cur[0] = i;
      for (j = 1; j <= bl; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
      }
      for (j = 0; j <= bl; j++) prev[j] = cur[j];
    }
    return prev[bl];
  }

  var ROC_ADDR_SUGGEST_MAX = 2;

  function rocAddrBestStreet(queryNorm, candidateNorms) {
    if (queryNorm === '') return null;
    var best = null, bestDistance = ROC_ADDR_SUGGEST_MAX + 1;
    for (var i = 0; i < candidateNorms.length; i++) {
      var cand = String(candidateNorms[i] || '');
      if (cand === '') continue;
      if (cand === queryNorm) return { norm: cand, distance: 0 };
      var d = rocAddrLevenshtein(queryNorm, cand);
      if (d < bestDistance) { bestDistance = d; best = cand; }
    }
    if (best === null || bestDistance > ROC_ADDR_SUGGEST_MAX) return null;
    return { norm: best, distance: bestDistance };
  }

  function rocAddrNormVariants(norm) {
    var n = String(norm == null ? '' : norm).replace(/^\s+|\s+$/g, '');
    if (n === '') return [];
    var out = [n];
    if (n.indexOf('/') !== -1) {
      var parts = n.split('/');
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i].replace(/^\s+|\s+$/g, '');
        if (part !== '' && out.indexOf(part) === -1) out.push(part);
      }
    }
    return out;
  }

  function rocAddrMatch(field, streets) {
    var parsed = rocAddrParseHouseNumber(field);
    if (parsed.street === '') return { status: 'empty', street: '', suggestion: '', number_ok: false };
    var queryNorm = rocAddrNormalizeStreet(parsed.street);

    var entries = [];
    var index = {};
    var seen = {};
    var norms = [];
    var list = streets || [];
    for (var i = 0; i < list.length; i++) {
      var row = list[i] || {};
      var norm = String(row.norm || '');
      if (norm === '') norm = rocAddrNormalizeStreet(row.street || '');
      if (norm === '') continue;
      if (!Object.prototype.hasOwnProperty.call(seen, norm)) {
        entries.push({ label: String(row.street || ''), numbers: [] });
        seen[norm] = entries.length - 1;
        var variants = rocAddrNormVariants(norm);
        for (var v = 0; v < variants.length; v++) {
          if (!Object.prototype.hasOwnProperty.call(index, variants[v])) {
            index[variants[v]] = seen[norm];
            norms.push(variants[v]);
          }
        }
      }
      var nums = row.numbers || [];
      for (var k = 0; k < nums.length; k++) { if (String(nums[k]) !== '') entries[seen[norm]].numbers.push(nums[k]); }
    }
    var best = null;
    var queryVariants = rocAddrNormVariants(queryNorm);
    for (var q = 0; q < queryVariants.length; q++) {
      var found = rocAddrBestStreet(queryVariants[q], norms);
      if (found === null) continue;
      if (best === null || found.distance < best.distance) best = found;
      if (best.distance === 0) break;
    }
    if (best === null) return { status: 'notfound', street: '', suggestion: '', number_ok: false };
    var entry = entries[index[best.norm]];
    var label = entry.label;
    var numberOk = rocAddrNumberMatches(parsed.number, entry.numbers);
    if (best.distance === 0) {

      return { status: numberOk ? 'exact' : 'numberUnknown', street: label, suggestion: '', number_ok: numberOk };
    }
    return { status: 'suggest', street: label, suggestion: label, number_ok: numberOk };
  }

  function rocAddrCityMatches(queryCity, dbCities) {

    var queryVariants = rocAddrNormVariants(rocAddrNormalizeStreet(queryCity));
    if (!queryVariants.length) return false;
    var list = dbCities || [];
    if (!list.length) return true;
    for (var i = 0; i < list.length; i++) {
      var variants = rocAddrNormVariants(rocAddrNormalizeStreet(list[i]));
      for (var v = 0; v < variants.length; v++) {
        if (queryVariants.indexOf(variants[v]) !== -1) return true;
      }
    }
    return false;
  }

  function rocNormalizeClientLocale(value) {
    var code = String(value == null ? '' : value).trim().toLowerCase().replace(/_/g, '-');
    if (!code) return '';
    var primary = code.split('-')[0];
    if (primary === 'de') return 'de_CH';
    if (primary === 'fr') return 'fr_CH';
    if (primary === 'en') return 'en_GB';
    return '';
  }

  function rocResolveCustomerLocale(settings) {
    var loc = (settings && settings.locales) || {};
    var allowed = (loc.allowed && loc.allowed.length) ? loc.allowed : ['de_CH', 'fr_CH', 'en_GB'];
    var fallback = (allowed.indexOf(loc.fallback) >= 0) ? loc.fallback : (allowed[0] || 'de_CH');
    var mode = loc.mode || 'fixed';
    function fromBrowser() {
      var langs = [];
      if (typeof navigator !== 'undefined') {
        if (navigator.languages && navigator.languages.length) langs = navigator.languages;
        else if (navigator.language) langs = [navigator.language];
      }
      for (var i = 0; i < langs.length; i++) {
        var m = rocNormalizeClientLocale(langs[i]);
        if (m && allowed.indexOf(m) >= 0) return m;
      }
      return '';
    }
    if (mode === 'selector') {
      var stored = '';
      try { stored = window.localStorage.getItem('roc_customer_locale') || ''; } catch (e) { stored = ''; }
      var s = rocNormalizeClientLocale(stored);
      if (s && allowed.indexOf(s) >= 0) return s;
      var b = fromBrowser();
      if (b) return b;
      return fallback;
    }
    if (mode === 'browser') {
      var bb = fromBrowser();
      if (bb) return bb;
      return fallback;
    }

    var fixed = rocNormalizeClientLocale(loc.fixed);
    if (fixed && allowed.indexOf(fixed) >= 0) return fixed;
    return fallback;
  }

  function rocCalendarLocale(loc) {
    var s = String(loc == null ? '' : loc).trim();
    return s ? s.replace(/_/g, '-') : undefined;
  }

  function rocBuildLangSwitcher(settings, customerLocale, root, data) {
    var allowed = (settings.locales && settings.locales.allowed && settings.locales.allowed.length)
      ? settings.locales.allowed
      : ['de_CH', 'fr_CH', 'en_GB'];
    var flagClass = { de_CH: 'roc__flag--de', fr_CH: 'roc__flag--fr', en_GB: 'roc__flag--gb' };
    var codeLabel = { de_CH: 'DE', fr_CH: 'FR', en_GB: 'EN' };
    var menu = el('div', { 'class': 'roc__lang-menu', role: 'menu', hidden: true });
    var btn = el('button', {
      type: 'button',
      'class': 'roc__lang',
      'aria-haspopup': 'true',
      'aria-expanded': 'false',
      'aria-label': t(settings, 'localeSwitcher', 'Sprache'),
      title: t(settings, 'localeSwitcher', 'Sprache')
    });
    var wrap = el('div', { 'class': 'roc__lang-wrap' }, [btn, menu]);
    function onDocClick(e) { if (!wrap.contains(e.target)) close(); }
    function onKey(e) { if (e.key === 'Escape' || e.key === 'Esc') { close(); btn.focus(); } }
    function open() {
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onDocClick);
      document.addEventListener('keydown', onKey);
    }
    function close() {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onKey);
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu.hidden) open(); else close();
    });
    allowed.forEach(function (loc) {
      var opt = el('button', {
        type: 'button',
        role: 'menuitem',
        lang: loc.replace('_', '-'),
        'data-loc': loc,
        'class': 'roc__lang-opt' + (loc === customerLocale ? ' is-active' : '')
      }, [
        el('span', { 'class': 'roc__flag ' + (flagClass[loc] || ''), 'aria-hidden': 'true' }),
        el('span', { 'class': 'roc__lang-code' }, [codeLabel[loc] || loc])
      ]);
      opt.addEventListener('click', function () {
        close();
        if (loc === customerLocale) return;
        try { window.localStorage.setItem('roc_customer_locale', loc); } catch (e) {  }

        var fresh = root.cloneNode(false);
        if (root.parentNode) {
          root.parentNode.replaceChild(fresh, root);
          render(fresh, data);
        } else {
          render(root, data);
        }
      });
      menu.appendChild(opt);
    });
    return wrap;
  }

  function maxQty(settings) {
    var max = parseInt(settings.maxQuantity, 10);
    return (max && max > 0) ? max : 99;
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    if (window.crypto && window.crypto.getRandomValues) {
      var b = window.crypto.getRandomValues(new Uint8Array(16));
      b[6] = (b[6] & 0x0f) | 0x40;
      b[8] = (b[8] & 0x3f) | 0x80;
      var h = [];
      for (var i = 0; i < 16; i++) h.push((b[i] + 0x100).toString(16).slice(1));
      return h[0] + h[1] + h[2] + h[3] + '-' + h[4] + h[5] + '-' + h[6] + h[7] + '-' + h[8] + h[9] + '-' + h[10] + h[11] + h[12] + h[13] + h[14] + h[15];
    }
    return 'roc-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  // Intl.DateTimeFormat-Konstruktionen sind teuer (Locale-/Zonendaten-Load) und liefen vor
  // 1.50.2 ~24'000x pro Boot durch die Slot-/Kalender-/Badge-Schleifen (PSI-Befund TBT/LCP).
  // Formatter werden deshalb je (fixes Format+Locale, Timezone) genau einmal gebaut und
  // wiederverwendet; "heute/jetzt" wird je Timezone pro SEKUNDEN-Tick memoisiert — innerhalb
  // eines Boot-/update-Durchlaufs konsistent, abgelaufene Slots bleiben maximal 1 s laenger
  // sichtbar als vorher (Server-Validator bleibt autoritativ, R1.22).
  var rocDtfDate = {};
  var rocDtfParts = {};
  var rocZonedMemo = {};

  function rocDateFormatter(tz) {
    if (!rocDtfDate[tz]) {
      rocDtfDate[tz] = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' });
    }
    return rocDtfDate[tz];
  }

  function rocPartsFormatter(tz) {
    if (!rocDtfParts[tz]) {
      rocDtfParts[tz] = new Intl.DateTimeFormat('en-GB', {
        timeZone: tz,
        weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      });
    }
    return rocDtfParts[tz];
  }

  var rocDtfWeekday = {};
  var rocDtfMonth = {};

  function rocWeekdayFormatter(locale) {
    if (!rocDtfWeekday[locale]) {
      rocDtfWeekday[locale] = new Intl.DateTimeFormat(locale, { weekday: 'short', timeZone: 'UTC' });
    }
    return rocDtfWeekday[locale];
  }

  function rocMonthFormatter(locale) {
    if (!rocDtfMonth[locale]) {
      rocDtfMonth[locale] = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric', timeZone: 'UTC' });
    }
    return rocDtfMonth[locale];
  }

  function rocZonedMemoFor(tz) {
    var tick = Math.floor(Date.now() / 1000);
    var memo = rocZonedMemo[tz];
    if (!memo || memo.tick !== tick) {
      memo = { tick: tick, dateStr: null, parts: null };
      rocZonedMemo[tz] = memo;
    }
    return memo;
  }

  function getZonedDate(timezone) {
    var tz = timezone || 'Europe/Zurich';
    var memo = rocZonedMemoFor(tz);
    if (null === memo.dateStr) {
      var parts = rocDateFormatter(tz).formatToParts(new Date());
      var map = {};
      parts.forEach(function (part) { map[part.type] = part.value; });
      memo.dateStr = map.year + '-' + map.month + '-' + map.day;
    }
    return memo.dateStr;
  }

  function dayDiff(fromStr, toStr) {
    var a = String(fromStr).split('-');
    var b = String(toStr).split('-');
    var ams = Date.UTC(Number(a[0]), Number(a[1]) - 1, Number(a[2]));
    var bms = Date.UTC(Number(b[0]), Number(b[1]) - 1, Number(b[2]));
    return Math.round((bms - ams) / 86400000);
  }

  function addDaysToDateStr(dateStr, n) {
    var p = String(dateStr).split('-');
    var d = new Date(Date.UTC(Number(p[0]), Number(p[1]) - 1, Number(p[2])));
    d.setUTCDate(d.getUTCDate() + n);
    var mo = d.getUTCMonth() + 1;
    var da = d.getUTCDate();
    return d.getUTCFullYear() + '-' + (mo < 10 ? '0' : '') + mo + '-' + (da < 10 ? '0' : '') + da;
  }

  function dayKeyFromDate(dateStr) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dateStr || ''));
    if (!m) return null;
    var d = new Date(Date.UTC(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10)));
    var keys = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    return keys[d.getUTCDay()];
  }

  function availableAt(hours, dayKey, minutes) {
    if (!hours || !dayKey || minutes === null) return false;
    var idx = DAYS.indexOf(dayKey);
    if (idx < 0) return false;
    var prev = DAYS[(idx + 6) % 7];
    return dayOpen(hours[dayKey], minutes, false) || dayOpen(hours[prev], minutes, true);
  }

  function getZonedParts(timezone) {
    var tz = timezone || 'Europe/Zurich';
    var memo = rocZonedMemoFor(tz);
    if (null === memo.parts) {
      var parts = rocPartsFormatter(tz).formatToParts(new Date());
      var map = {};
      parts.forEach(function (part) { map[part.type] = part.value; });
      var dayMap = { Mon: 'mon', Tue: 'tue', Wed: 'wed', Thu: 'thu', Fri: 'fri', Sat: 'sat', Sun: 'sun' };
      memo.parts = { day: dayMap[map.weekday] || 'mon', minutes: parseInt(map.hour, 10) * 60 + parseInt(map.minute, 10), seconds: parseInt(map.second, 10) || 0 };
    }
    // Kopie zurueckgeben — Aufrufer duerfen das Memo-Objekt nicht mutieren.
    return { day: memo.parts.day, minutes: memo.parts.minutes, seconds: memo.parts.seconds };
  }

  function parseTimeToMinutes(value) {
    var match = String(value || '').trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return null;
    var h = parseInt(match[1], 10);
    var m = parseInt(match[2], 10);
    if (h < 0 || h > 23 || m < 0 || m > 59) return null;
    return h * 60 + m;
  }

  function formatMinutes(minutes) {
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
  }

  function dayOpen(config, minutes, asPrevTail) {
    if (!config || config.closed === '1' || !config.slots) return false;
    return String(config.slots).split(',').some(function (slot) {
      var parts = slot.split('-');
      if (parts.length !== 2) return false;
      var start = parseTimeToMinutes(parts[0]);
      var end = parseTimeToMinutes(parts[1]);
      if (start === null || end === null) return false;
      if (end < start) {

        return asPrevTail ? minutes <= end : minutes >= start;
      }

      return asPrevTail ? false : (minutes >= start && minutes <= end);
    });
  }

  function isOpen(settings) {
    var zoned = getZonedParts(settings.timezone);
    var hours = settings.hours || {};
    var idx = DAYS.indexOf(zoned.day);
    if (idx < 0) idx = 0;
    var prevDay = DAYS[(idx + 6) % 7];
    if (dayOpen(hours[zoned.day], zoned.minutes, false)) return true;
    if (dayOpen(hours[prevDay], zoned.minutes, true)) return true;
    return false;
  }

  function groupByCategory(items, fallbackCategory) {
    var groups = {};
    items.forEach(function (item) {
      var category = item.category || fallbackCategory;
      groups[category] = groups[category] || [];
      groups[category].push(item);
    });
    return groups;
  }

  function normalizePostcode(zip) {
    return String(zip == null ? '' : zip).replace(/\s+/g, '');
  }

  function findZone(settings, zip) {
    var pc = normalizePostcode(zip);
    if (!pc) return null;
    var zones = settings.deliveryZones || [];
    for (var i = 0; i < zones.length; i++) {
      if (String(zones[i].postcode) === pc) return zones[i];
    }
    return null;
  }

  function deliveryRates(settings, state) {
    if (state.type !== 'delivery') return { fee: 0, min: 0, served: true };
    var flat = { fee: Number(settings.deliveryFee || 0), min: Number(settings.minDeliveryTotal || 0), served: true };
    if (settings.zonesEnabled) {
      if (!normalizePostcode(state.zip)) return { fee: 0, min: 0, served: true };
      var zone = findZone(settings, state.zip);
      if (zone) return { fee: Number(zone.fee || 0), min: Number(zone.min || 0), served: true };
      if (settings.deliveryFlatFallback) return flat;
      return { fee: 0, min: 0, served: false };
    }
    return flat;
  }

  function cartSubtotal(state, itemsById) {
    var sub = 0;
    Object.keys(state.cart).forEach(function (id) {
      var qty = state.cart[id];
      var item = itemsById[id];
      if (qty && item) sub += qty * Number(item.price || 0);
    });
    Object.keys(state.configuredCart || {}).forEach(function (key) {
      var line = state.configuredCart[key];
      if (line && line.qty) sub += line.qty * Number(line.unitDisplayPrice || 0);
    });
    return sub;
  }

  function minHint(settings, min, sub) {
    var tpl = t(settings, 'minZoneHint', 'Mindestbestellwert: %1$s. Aktueller Warenwert: %2$s.');
    return tpl.replace('%1$s', money(min, settings.currency)).replace('%2$s', money(sub, settings.currency));
  }

  function rocDeliveryFeedback(settings, state, subtotal) {
    if (state.type !== 'delivery') return { mode: 'hidden' };
    if (!normalizePostcode(state.zip)) return { mode: 'prompt' };
    var rates = deliveryRates(settings, state);
    if (!rates.served) return { mode: 'unserved' };
    var min = Number(rates.min || 0);
    var sub = Number(subtotal || 0);
    return {
      mode: 'ok',
      served: true,
      fee: Number(rates.fee || 0),
      min: min,
      subtotal: sub,
      missing: min > sub ? (min - sub) : 0,
      reached: min <= 0 || sub >= min
    };
  }

  function buildMessage(state, settings, itemsById) {
    var lines = [];
    var total = 0;
    lines.push(t(settings, 'order', 'Bestellung') + ': ' + (settings.restaurantName || 'Restaurant'));
    lines.push('');
    Object.keys(state.cart).forEach(function (id) {
      var qty = state.cart[id];
      if (!qty) return;
      var item = itemsById[id];
      if (!item) return;
      var lineTotal = qty * Number(item.price || 0);
      total += lineTotal;
      lines.push(qty + 'x ' + item.name + ' - ' + money(lineTotal, settings.currency));
    });
    Object.keys(state.configuredCart || {}).forEach(function (key) {
      var line = state.configuredCart[key];
      if (!line || !line.qty) return;
      var cfgTotal = line.qty * Number(line.unitDisplayPrice || 0);
      total += cfgTotal;
      lines.push(line.qty + 'x ' + ((itemsById[line.id] && itemsById[line.id].name) || line.displayName) + ' - ' + money(cfgTotal, settings.currency));
      (line.optionLabels || []).forEach(function (lbl) { lines.push('  + ' + lbl); });
    });
    if (state.type === 'delivery') {
      var feeRates = deliveryRates(settings, state);
      if (feeRates.fee > 0) {
        total += feeRates.fee;
        lines.push(t(settings, 'deliveryFee', 'Liefergebuehr') + ' - ' + money(feeRates.fee, settings.currency));
      }
    }
    lines.push('');
    lines.push(t(settings, 'total', 'Total') + ': ' + money(total, settings.currency));
    lines.push(t(settings, 'orderType', 'Bestellart') + ': ' + (state.type === 'delivery' ? t(settings, 'delivery', 'Lieferung') : t(settings, 'pickup', 'Abholung')));
    if (state.date && state.time) lines.push(t(settings, 'requestedAt', 'Wunschtermin') + ': ' + state.date + ' ' + state.time);
    var fullName = [state.firstName, state.lastName].filter(Boolean).join(' ').trim();
    if (fullName) lines.push(t(settings, 'name', 'Name') + ': ' + fullName);
    if (state.phone) lines.push(t(settings, 'phone', 'Telefon') + ': ' + state.phone);
    if (state.type === 'delivery') {
      var addr = [state.street, state.zip, state.city].filter(Boolean).join(', ');
      if (addr) lines.push(t(settings, 'address', 'Adresse') + ': ' + addr);
    }
    if (state.comment) lines.push(t(settings, 'remark', 'Bemerkung') + ': ' + state.comment);
    if (settings.orderNote) {
      lines.push('');
      lines.push(settings.orderNote);
    }
    return { text: lines.join('\n'), total: total };
  }

  function isValidChPhone(value) {
    var digits = String(value == null ? '' : value).replace(/\D+/g, '');
    if (!digits) return false;
    var significant;
    if (digits.indexOf('0041') === 0) significant = digits.slice(4);
    else if (digits.indexOf('41') === 0 && digits.length === 11) significant = digits.slice(2);
    else if (digits.indexOf('0') === 0) significant = digits.slice(1);
    else significant = digits;
    return /^[2-9]\d{8}$/.test(significant);
  }

  function isDeliveryPhoneAcceptable(value) {
    if (isValidChPhone(value)) return true;
    var raw = String(value == null ? '' : value);
    var digits = raw.replace(/\D+/g, '');
    return /^\s*(?:\+|00)/.test(raw) && digits.length >= 8;
  }

  function serviceWindowStartAbs(settings, state, dateStr, minutes) {
    var opening = settings.hours || {};
    var plan = state.type === 'delivery' ? (settings.hoursDelivery || {}) : (settings.hoursTakeaway || {});
    var abs = minutes;
    for (var i = 0; i < 96; i++) {
      var prevAbs = abs - 15;
      var dayOffset = Math.floor(prevAbs / 1440);
      var mod = ((prevAbs % 1440) + 1440) % 1440;
      var dk = dayKeyFromDate(addDaysToDateStr(dateStr, dayOffset));
      if (!(availableAt(opening, dk, mod) && availableAt(plan, dk, mod))) break;
      abs = prevAbs;
    }
    return abs;
  }

  function slotBookable(settings, state, dateStr, minutes) {

    if (state.type !== 'pickup' && state.type !== 'delivery') return false;
    if (minutes === null || minutes % 15 !== 0) return false;
    var dayKey = dayKeyFromDate(dateStr);
    if (!dayKey) return false;

    if (!serviceAllowedOnDate(settings, dateStr, state.type)) return false;
    var todayStr = getZonedDate(settings.timezone);
    var nowParts = getZonedParts(settings.timezone);
    var nowMinutes = nowParts.minutes;
    if (dateStr < todayStr || (dateStr === todayStr && minutes <= nowMinutes)) return false;
    var lead = Number(settings.leadMinutes || 0);

    if (lead > 0 && ((dayDiff(todayStr, dateStr) * 1440 + minutes) * 60) < ((nowMinutes + lead) * 60 + nowParts.seconds)) return false;
    var opening = settings.hours || {};
    var plan = state.type === 'delivery' ? (settings.hoursDelivery || {}) : (settings.hoursTakeaway || {});
    if (!availableAt(opening, dayKey, minutes)) return false;
    if (!availableAt(plan, dayKey, minutes)) return false;

    if (lead > 0 && minutes < serviceWindowStartAbs(settings, state, dateStr, minutes) + lead) return false;
    return true;
  }

  function bookableSlotMinutes(settings, state, dateStr) {
    var out = [];
    for (var minutes = 0; minutes < 1440; minutes += 15) {
      if (slotBookable(settings, state, dateStr, minutes)) out.push(minutes);
    }
    return out;
  }

  function nextBookableSlot(settings, type) {
    if (type !== 'delivery' && type !== 'pickup') return null;
    var todayStr = getZonedDate(settings.timezone);
    var horizon = Math.max(1, Number(settings.horizonDays || 1));
    for (var d = 0; d <= horizon; d++) {
      var dateStr = addDaysToDateStr(todayStr, d);
      var mins = bookableSlotMinutes(settings, { type: type }, dateStr);
      if (mins.length) return { date: dateStr, minutes: mins[0] };
    }
    return null;
  }

  function nextOpenMoment(settings) {
    var todayStr = getZonedDate(settings.timezone);
    var horizon = Math.max(1, Number(settings.horizonDays || 1));
    var np = getZonedParts(settings.timezone);
    for (var d = 0; d <= horizon; d++) {
      var dateStr = addDaysToDateStr(todayStr, d);
      if (specialDayMode(settings, dateStr) === 'closed') continue;
      var dk = dayKeyFromDate(dateStr);
      var startMin = d === 0 ? np.minutes : 0;
      for (var m = startMin; m < 1440; m += 1) {
        if (availableAt(settings.hours || {}, dk, m)) return { date: dateStr, minutes: m };
      }
    }
    return null;
  }

  function scopeAvailableAt(settings, scope, dayKey, minutes) {
    if (!availableAt(settings.hours || {}, dayKey, minutes)) return false;
    if (scope === 'delivery') return availableAt(settings.hoursDelivery || {}, dayKey, minutes);
    if (scope === 'pickup') return availableAt(settings.hoursTakeaway || {}, dayKey, minutes);
    return true;
  }

  function currentAvailabilityEnd(settings, scope, dateStr, nowMinutes) {
    function availAbs(a) {
      var off = Math.floor(a / 1440);
      var mod = ((a % 1440) + 1440) % 1440;
      return scopeAvailableAt(settings, scope, dayKeyFromDate(addDaysToDateStr(dateStr, off)), mod);
    }
    if (!availAbs(nowMinutes)) return null;
    var abs = nowMinutes;
    var guard = 0;
    while (availAbs(abs + 1) && guard < 1441) { abs += 1; guard++; }
    return abs;
  }

  function fmt1(template, value) { return String(template).replace('%s', String(value)); }

  function fmt2(template, a, b) { return String(template).replace('%1$s', String(a)).replace('%2$s', String(b)); }

  function relDay(settings, dateStr) {
    var diff = dayDiff(getZonedDate(settings.timezone), dateStr);
    if (diff === 0) return t(settings, 'badgeToday', 'heute');
    if (diff === 1) return t(settings, 'badgeTomorrow', 'morgen');
    var p = String(dateStr).split('-');
    return p[2] + '.' + p[1] + '.';
  }

  function slotLabel(settings, slot) {
    return relDay(settings, slot.date) + ' ' + formatMinutes(slot.minutes);
  }

  function endLabel(settings, absEnd) {
    var time = formatMinutes(((absEnd % 1440) + 1440) % 1440);
    return absEnd >= 1440 ? t(settings, 'badgeTomorrow', 'morgen') + ' ' + time : time;
  }

  function rocCheckService(state, settings) {
    if (state.type !== 'pickup' && state.type !== 'delivery') return 'requireType';

    if (settings && !nextBookableSlot(settings, state.type)) {
      return state.type === 'delivery' ? 'deliveryNotBookable' : 'pickupNotBookable';
    }
    return '';
  }

  function rocCheckContact(state) {
    if (!String(state.firstName).trim() || !String(state.lastName).trim() || !String(state.phone).trim()) return 'requireContact';
    return '';
  }
  function rocCheckDeliveryPhone(state) {
    if (state.type === 'delivery' && !isDeliveryPhoneAcceptable(state.phone)) return 'invalidPhone';
    return '';
  }

  function rocCheckAddress(state, settings, addrScope) {
    if (state.type !== 'delivery') return '';
    if (!String(state.street).trim() || !String(state.zip).trim() || !String(state.city).trim()) return 'requireAddress';
    if (!/^[1-9]\d{3}$/.test(String(state.zip).trim())) return 'invalidZip';
    if (settings && settings.addressCheckMode === 'hard') {
      if (rocAddrParseHouseNumber(state.street).number === '') return 'addressNumberRequired';
      if (addrScope && addrScope.data && addrScope.zip === String(state.zip).trim()) {

        if (addrScope.count <= 0) return 'addressUnverifiable';
        if (!rocAddrCityMatches(state.city, addrScope.data.cities || [])) return 'addressNotFound';
        var streetResult = rocAddrMatch(state.street, addrScope.data.streets || []);

        if (streetResult.status === 'numberUnknown') return 'addressNumberUnknown';
        if (streetResult.status !== 'exact') return 'addressNotFound';
      }
    }
    return '';
  }

  function rocCheckTime(state, settings) {
    if (!String(state.date).trim()) return 'requireSlot';
    var specialMode = specialDayMode(settings, state.date);
    if (specialMode === 'closed') return 'dateClosed';
    if (specialMode === 'delivery_disabled' && state.type === 'delivery') return 'deliveryDayUnavailable';
    if (specialMode === 'pickup_disabled' && state.type === 'pickup') return 'pickupDayUnavailable';
    if (!String(state.time).trim()) return 'requireSlot';
    var dayKey = dayKeyFromDate(state.date);
    var minutes = parseTimeToMinutes(state.time);
    if (!dayKey || minutes === null) return 'requireSlot';
    if (minutes % 15 !== 0) return 'slotUnavailable';
    var todayStr = getZonedDate(settings.timezone);
    var nowParts = getZonedParts(settings.timezone);
    var nowMinutes = nowParts.minutes;
    if (state.date < todayStr || (state.date === todayStr && minutes <= nowMinutes)) return 'slotPast';
    var lead = Number(settings.leadMinutes || 0);
    if (lead > 0 && ((dayDiff(todayStr, state.date) * 1440 + minutes) * 60) < ((nowMinutes + lead) * 60 + nowParts.seconds)) return 'slotLead';
    var opening = settings.hours || {};
    var plan = state.type === 'delivery' ? (settings.hoursDelivery || {}) : (settings.hoursTakeaway || {});
    if (!availableAt(opening, dayKey, minutes)) return 'slotUnavailable';
    if (!availableAt(plan, dayKey, minutes)) return (state.type === 'delivery' ? 'slotDeliveryUnavailable' : 'slotPickupUnavailable');
    if (lead > 0 && minutes < serviceWindowStartAbs(settings, state, state.date, minutes) + lead) return 'slotLead';
    return '';
  }

  function rocStepGate(step, state, settings, addrScope) {
    switch (step) {
      case 'service': return rocCheckService(state, settings);
      case 'address': return rocCheckAddress(state, settings, addrScope);
      case 'time': return rocCheckTime(state, settings);
      case 'contact': return rocCheckContact(state) || rocCheckDeliveryPhone(state);
      default: return '';
    }
  }

  function rocStepBlockIndex(passes) {
    for (var i = 0; i < passes.length; i++) { if (!passes[i]) return i; }
    return passes.length;
  }

  function rocStepReachableGated(targetIdx, blockIdx, currentIdx) {
    return targetIdx <= blockIdx || targetIdx === currentIdx;
  }

  function validationError(state, settings, channel, addrScope) {

    var e = rocCheckService(state, settings); if (e) return e;
    e = rocCheckContact(state); if (e) return e;
    if (channel === 'mail' && !String(state.email).trim()) return 'requireEmail';
    if (channel === 'phone') {

      var phoneMode = specialDayMode(settings, getZonedDate(settings.timezone));
      if (phoneMode === 'closed') return 'dateClosed';
      if (phoneMode === 'delivery_disabled' && state.type === 'delivery') return 'deliveryDayUnavailable';
      if (phoneMode === 'pickup_disabled' && state.type === 'pickup') return 'pickupDayUnavailable';
      return null;
    }
    e = rocCheckDeliveryPhone(state); if (e) return e;
    e = rocCheckAddress(state, settings, addrScope); if (e) return e;

    e = rocCheckTime(state, settings); if (e) return e;

    var paymentOffered = settings.paymentCashEnabled || settings.paymentCardEnabled || settings.paymentOnlineEnabled;
    if (paymentOffered && !String(state.paymentMethod).trim()) return 'requirePayment';
    return null;
  }

  function captchaApiSrc(provider) {
    if (provider === 'turnstile') return 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=rocCaptchaApiReady&render=explicit';
    if (provider === 'recaptcha') return 'https://www.google.com/recaptcha/api.js?onload=rocCaptchaApiReady&render=explicit';
    return '';
  }

  function rocCaptchaApi(provider) {
    if (provider === 'turnstile' && window.turnstile && typeof window.turnstile.render === 'function') return window.turnstile;
    if (provider === 'recaptcha' && window.grecaptcha && typeof window.grecaptcha.render === 'function') return window.grecaptcha;
    return null;
  }

  var rocCaptchaPending = [];

  if (typeof window !== 'undefined') {
    window.rocCaptchaApiReady = function () {
      var jobs = rocCaptchaPending.splice(0, rocCaptchaPending.length);
      jobs.forEach(function (job) {
        job.box.removeAttribute('data-roc-captcha-queued');
        rocRenderCaptcha(job.box, job.provider, job.sitekey);
      });
    };
  }

  function rocRenderCaptcha(box, provider, sitekey) {
    if (!box || box.getAttribute('data-roc-captcha-rendered')) return;
    var target = box.querySelector('.roc__captcha');
    if (!target || !sitekey) return;
    var step = box.closest ? box.closest('[data-step]') : null;
    if (step && step.hidden) return;
    var api = rocCaptchaApi(provider);
    if (!api) {
      if (!box.getAttribute('data-roc-captcha-queued')) {
        box.setAttribute('data-roc-captcha-queued', '1');
        rocCaptchaPending.push({ box: box, provider: provider, sitekey: sitekey });
      }
      return;
    }
    try {
      var widgetId = api.render(target, { sitekey: sitekey });
      box.setAttribute('data-roc-captcha-rendered', '1');
      if (widgetId !== undefined && widgetId !== null) box.setAttribute('data-roc-captcha-widget', String(widgetId));
    } catch (e) {  }
  }

  function ensureCaptchaScript(provider) {
    var src = captchaApiSrc(provider);
    if (!src || document.querySelector('script[data-roc-captcha]')) return;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.defer = true;
    s.setAttribute('data-roc-captcha', provider);

    var parent = document.head || document.body || document.documentElement;
    if (parent) parent.appendChild(s);
  }

  function readCaptchaToken(root) {
    var field = root.querySelector('[name="cf-turnstile-response"], [name="g-recaptcha-response"]');
    return field ? String(field.value || '') : '';
  }

  function resetCaptcha(provider, box) {
    try {
      var api = rocCaptchaApi(provider);
      if (!api) return;
      var id = box ? box.getAttribute('data-roc-captcha-widget') : null;
      if (id !== null && id !== undefined && id !== '') {
        api.reset(provider === 'recaptcha' ? parseInt(id, 10) : id);
      } else {
        api.reset();
      }
    } catch (e) {  }
  }

  function optionNameNode(name) {
    var raw = String(name == null ? '' : name);
    var pos = raw.indexOf(' / ');
    if (pos < 0) return el('span', { 'class': 'roc__mg-optname' }, [raw]);
    return el('span', { 'class': 'roc__mg-optname' }, [
      el('span', { 'class': 'roc__mg-optname-main' }, [raw.slice(0, pos)]),
      el('span', { 'class': 'roc__mg-optname-alt' }, [raw.slice(pos + 3)])
    ]);
  }

  function rocModName(obj, locale) {
    var tr = obj && obj.i18n && obj.i18n[locale];
    if (tr && typeof tr.name === 'string' && tr.name !== '') return tr.name;
    return (obj && obj.name != null) ? String(obj.name) : '';
  }

  function discountLabel(rule, locale) {
    var tr = rule && rule.i18n && rule.i18n[locale];
    if (tr && typeof tr.label === 'string' && tr.label !== '') return tr.label;
    return (rule && rule.label != null) ? String(rule.label) : '';
  }

  function rocLocalizeItem(item, locale) {
    var tr = item && item.i18n && item.i18n[locale];
    if (!tr) return item;
    var out = item, copied = false, fields = ['name', 'description', 'note'], i, k, v;
    for (i = 0; i < fields.length; i++) {
      v = tr[fields[i]];
      if (v != null && v !== '') {
        if (!copied) { out = {}; for (k in item) { if (Object.prototype.hasOwnProperty.call(item, k)) { out[k] = item[k]; } } copied = true; }
        out[fields[i]] = v;
      }
    }
    return out;
  }

  function render(root, data) {

    var rocInstanceId = (root.getAttribute && root.getAttribute('data-roc-instance')) || '';
    rocClearWinListeners(rocInstanceId);
    var settings = data.settings || {};

    var customerLocale = rocResolveCustomerLocale(settings);
    if (settings.i18nByLocale && settings.i18nByLocale[customerLocale]) {
      settings.i18n = settings.i18nByLocale[customerLocale];
    } else {
      settings.i18n = settings.i18n || {};
    }

    var rootLang = rocCalendarLocale(customerLocale);
    if (rootLang) root.setAttribute('lang', rootLang);

    var items = (data.items || []).map(function (rocIt) { return rocLocalizeItem(rocIt, customerLocale); });
    var order = data.order || null;
    var itemsById = {};
    items.forEach(function (item) { itemsById[item.id] = item; });

    var hasNumber = !!(settings.whatsappNumber && String(settings.whatsappNumber).length);
    var hasType = !!(settings.pickupEnabled || settings.deliveryEnabled);

    var hasServer = !!(order && order.endpoint);

    var defaultType = '';
    var limit = maxQty(settings);
    var state = { cart: {}, configuredCart: {}, customerLocale: customerLocale, type: defaultType, firstName: '', lastName: '', phone: '', email: '', street: '', zip: '', city: '', date: '', time: '', comment: '', website: '', paymentMethod: '', idempotencyKey: null, submitting: false };

    var cartPanelVisible = false;
    var lastCartbarCount = 0;
    var wizMiniSubtotal = 0;
    var todayStr = getZonedDate(settings.timezone);

    var maxDateStr = addDaysToDateStr(todayStr, Number(settings.horizonDays || 30));

    var calView = (function () { var p = String(todayStr).split('-'); return { y: parseInt(p[0], 10), m: parseInt(p[1], 10) - 1 }; })();

    var storeKey = root.getAttribute('data-roc-storage-key')
      || ('roc_cart_' + (root.getAttribute('data-roc-instance') || 'default'));
    function persistCart() {
      try {
        var keep = {};
        var any = false;
        Object.keys(state.cart).forEach(function (id) {
          var qty = state.cart[id];
          if (qty > 0 && itemsById[id]) { keep[id] = qty; any = true; }
        });
        var configured = {};
        var anyConfigured = false;
        Object.keys(state.configuredCart).forEach(function (key) {
          var line = state.configuredCart[key];
          if (line && line.qty > 0 && itemsById[line.id]) { configured[key] = line; anyConfigured = true; }
        });
        if (any || anyConfigured) {
          window.sessionStorage.setItem(storeKey, JSON.stringify({ cart: keep, configured: configured, type: state.type }));
        } else {
          window.sessionStorage.removeItem(storeKey);
        }
      } catch (e) {  }
    }
    (function restoreCart() {
      var saved = null;
      try { saved = JSON.parse(window.sessionStorage.getItem(storeKey) || 'null'); } catch (e) { saved = null; }
      if (!saved || typeof saved !== 'object') return;
      if (saved.cart && typeof saved.cart === 'object') {
        Object.keys(saved.cart).forEach(function (id) {
          if (!itemsById[id]) return;
          var qty = Math.max(0, Math.min(limit, parseInt(saved.cart[id], 10) || 0));
          if (qty > 0) state.cart[id] = qty;
        });
      }

      if (saved.configured && typeof saved.configured === 'object') {
        Object.keys(saved.configured).forEach(function (key) {
          var line = saved.configured[key];
          if (!line || !itemsById[line.id]) return;
          var qty = Math.max(0, Math.min(limit, parseInt(line.qty, 10) || 0));
          if (qty > 0) {
            state.configuredCart[key] = {
              id: parseInt(line.id, 10),
              qty: qty,
              modifiers: Array.isArray(line.modifiers) ? line.modifiers : [],
              displayName: String(line.displayName || (itemsById[line.id] && itemsById[line.id].name) || ''),
              optionLabels: Array.isArray(line.optionLabels) ? line.optionLabels : [],
              unitDisplayPrice: Number(line.unitDisplayPrice || 0),
              unitDisplayPriceCents: Number(line.unitDisplayPriceCents || 0)
            };
          }
        });
      }

    })();

    var liveStoreKey = 'roc_live_' + storeKey.replace(/^roc_cart_/, '');
    function persistLive(token, endpoint, orderNumber) {
      try {
        window.sessionStorage.setItem(liveStoreKey, JSON.stringify({
          token: String(token || ''),
          endpoint: String(endpoint || ''),
          order_number: orderNumber != null ? String(orderNumber) : '',
          expires_at_ms: Date.now() + (liveRemaining > 0 ? liveRemaining : 240) * 1000,
          idempotencyKey: state.idempotencyKey || null
        }));
      } catch (e) {  }
    }
    function clearLive() {
      try { window.sessionStorage.removeItem(liveStoreKey); } catch (e) {  }
    }
    function readLive() {
      var t = null;
      try { t = JSON.parse(window.sessionStorage.getItem(liveStoreKey) || 'null'); } catch (e) { t = null; }
      if (!t || typeof t !== 'object' || !t.token || !t.endpoint) return null;
      return t;
    }

    function hasModifierGroups(item) {
      return !!(item && item.modifierGroups && item.modifierGroups.length);
    }

    function configKey(productId, selection) {
      var parts = selection.map(function (entry) {
        return entry.group + ':' + entry.options.slice().sort().join(',');
      }).sort();
      return String(productId) + '#' + parts.join('|');
    }

    function effectiveOptionDelta(opt, body) {
      var flat = Number((opt && opt.priceDeltaCents) || 0);
      var pr = opt && opt.priceRules;
      if (!pr || !pr.contextGroup || !pr.byOption) { return flat; }
      var sel = body.querySelector('input[data-group="' + pr.contextGroup + '"]:checked');
      if (!sel) { return flat; }
      var key = sel.value;
      if (Object.prototype.hasOwnProperty.call(pr.byOption, key)) { return Number(pr.byOption[key] || 0); }
      return flat;
    }

    function collectSelection(item, body) {
      var selection = [];
      var labels = [];
      var deltaCents = 0;
      item.modifierGroups.forEach(function (group) {
        var checked = body.querySelectorAll('input[data-group="' + group.slug + '"]:checked');
        var slugs = [];
        Array.prototype.forEach.call(checked, function (input) {
          var slug = input.value;
          slugs.push(slug);
          group.options.forEach(function (opt) {
            if (opt.slug === slug) {
              labels.push(rocModName(opt, customerLocale));
              deltaCents += effectiveOptionDelta(opt, body);
            }
          });
        });
        if (slugs.length) selection.push({ group: group.slug, options: slugs });
      });
      return { selection: selection, labels: labels, deltaCents: deltaCents };
    }

    function configuredOptionLabels(line) {
      var item = itemsById[line.id];
      var groups = item && item.modifierGroups;
      var sel = Array.isArray(line.modifiers) ? line.modifiers : [];
      if (!groups || !groups.length || !sel.length) return line.optionLabels || [];
      var out = [];
      sel.forEach(function (pick) {
        var gslug = pick && pick.group, group = null, i, j;
        for (i = 0; i < groups.length; i++) { if (groups[i].slug === gslug) { group = groups[i]; break; } }
        if (!group || !group.options) return;
        (pick.options || []).forEach(function (oslug) {
          for (j = 0; j < group.options.length; j++) {
            if (group.options[j].slug === oslug) { out.push(rocModName(group.options[j], customerLocale)); break; }
          }
        });
      });
      return out.length ? out : (line.optionLabels || []);
    }

    function selectionError(item, body) {
      for (var i = 0; i < item.modifierGroups.length; i++) {
        var group = item.modifierGroups[i];
        var count = body.querySelectorAll('input[data-group="' + group.slug + '"]:checked').length;
        var min = Number(group.minSelect || 0);
        var max = Number(group.maxSelect || 0);
        if (group.required && count < 1) {
          return { slug: group.slug, message: t(settings, 'modifierRequiredMissing', 'Bitte die Pflichtoptionen waehlen.') };
        }
        if (min > 0 && count < min) {
          return { slug: group.slug, message: t(settings, 'modifierMinSelect', 'Bitte mindestens %1$s Option(en) waehlen.').replace('%1$s', String(min)) };
        }
        if (max > 0 && count > max) {
          return { slug: group.slug, message: t(settings, 'modifierMaxSelect', 'Bitte hoechstens %1$s Option(en) waehlen.').replace('%1$s', String(max)) };
        }
      }
      return null;
    }
    function closeConfigurator() {
      var modal = root.querySelector('[data-config-modal]');
      if (modal) modal.hidden = true;
      root.classList.remove('roc--modal-open');
    }

    function openConfigurator(item) {
      var modal = root.querySelector('[data-config-modal]');
      var body = modal.querySelector('[data-config-body]');
      var title = modal.querySelector('[data-config-title]');
      var err = modal.querySelector('[data-config-error]');
      var priceEl = modal.querySelector('[data-config-price]');
      var addBtn = modal.querySelector('[data-config-add]');
      title.textContent = item.name;
      err.textContent = '';
      body.textContent = '';

      var iconsHost = modal.querySelector('[data-config-icons]');
      if (iconsHost) {
        iconsHost.textContent = '';
        var hintRow = hintIconRow(item, 'roc__hints--popup');
        if (hintRow) { iconsHost.appendChild(hintRow); iconsHost.hidden = false; } else { iconsHost.hidden = true; }
      }

      if (!item.modifierGroups) { item.modifierGroups = []; }

      var imgEl = modal.querySelector('[data-config-img]');
      var headEl = modal.querySelector('[data-config-head]');
      var pImgUrl = item.image ? (item.image.popup || item.image.thumb) : null;
      var catIco = itemCatIcon[item.id] || null;
      var pImg = pImgUrl ? { url: pImgUrl, alt: (item.image.alt || item.name) }
               : (catIco && (catIco.popup || catIco.url) ? { url: (catIco.popup || catIco.url), alt: (catIco.alt || item.name) } : null);
      if (imgEl) {
        if (pImg) { imgEl.src = pImg.url; imgEl.alt = pImg.alt; imgEl.hidden = false; if (headEl) { headEl.classList.add('roc__mg-head--img'); } }
        else { imgEl.removeAttribute('src'); imgEl.alt = ''; imgEl.hidden = true; if (headEl) { headEl.classList.remove('roc__mg-head--img'); } }
      }

      var COLLAPSE_N = 3;
      var collapseState = {};

      var ctxSlugs = {};
      item.modifierGroups.forEach(function (group) {
        group.options.forEach(function (opt) {
          if (opt.priceRules && opt.priceRules.contextGroup) { ctxSlugs[opt.priceRules.contextGroup] = true; }
        });
      });
      var orderedGroups = item.modifierGroups.filter(function (g) { return ctxSlugs[g.slug]; })
        .concat(item.modifierGroups.filter(function (g) { return !ctxSlugs[g.slug]; }));
      var dynamicPrices = [];

      function optionPriceText(opt, body) {
        var pr = opt.priceRules;
        if (pr && pr.contextGroup && pr.byOption) {
          var sel = body.querySelector('input[data-group="' + pr.contextGroup + '"]:checked');
          if (!sel) {
            var vals = [];
            for (var k in pr.byOption) {
              if (Object.prototype.hasOwnProperty.call(pr.byOption, k)) { vals.push(Number(pr.byOption[k] || 0)); }
            }
            var min = vals.length ? Math.min.apply(null, vals) : Number(opt.priceDeltaCents || 0);
            return ' (' + t(settings, 'modifierPriceFrom', 'ab %s').replace('%s', money(min / 100, settings.currency)) + ')';
          }
        }
        var d = effectiveOptionDelta(opt, body);
        return d > 0 ? ' (+' + money(d / 100, settings.currency) + ')' : '';
      }
      orderedGroups.forEach(function (group) {
        var inputType = group.type === 'multiple' ? 'checkbox' : 'radio';
        var optionNodes = group.options.map(function (opt, idx) {
          var input = el('input', { type: inputType, name: 'roc-mg-' + group.slug, 'data-group': group.slug, value: opt.slug });
          var priceSpan = el('span', { 'class': 'roc__mg-optprice' }, [optionPriceText(opt, body)]);
          if (opt.priceRules) { dynamicPrices.push({ span: priceSpan, opt: opt }); }
          return el('label', { 'class': 'roc__mg-option', 'data-opt-index': String(idx) }, [input, optionNameNode(rocModName(opt, customerLocale)), priceSpan]);
        });
        var legendNode = el('legend', { 'class': 'roc__mg-legend' }, [
          el('span', { 'class': 'roc__mg-legend-text' }, groupLegendNodes(rocModName(group, customerLocale), group.required)),
          el('span', { 'class': 'roc__mg-maxnote', hidden: true }, [' \u2014 ' + t(settings, 'modifierMaxReached', 'Maximum erreicht')]),
        ]);
        var children = [legendNode].concat(optionNodes);
        if (group.options.length > COLLAPSE_N) {
          collapseState[group.slug] = false;
          var toggle = el('button', { type: 'button', 'class': 'roc__mg-toggle', 'data-group-toggle': group.slug, 'aria-expanded': 'false', hidden: true }, []);
          toggle.onclick = (function (slug) {
            return function () { collapseState[slug] = !collapseState[slug]; applyCollapse(); };
          })(group.slug);
          children.push(toggle);
        }
        body.appendChild(el('fieldset', { 'class': 'roc__mg-group', 'data-group-fs': group.slug }, children));
      });

      item.modifierGroups.forEach(function (group) {
        if (group.options.length <= COLLAPSE_N) { return; }
        var fs = body.querySelector('fieldset[data-group-fs="' + group.slug + '"]');
        if (!fs) { return; }
        var opts = fs.querySelectorAll('.roc__mg-option');
        for (var i = COLLAPSE_N; i < opts.length; i++) {
          var inp = opts[i].querySelector('input');
          if (inp && inp.checked) { collapseState[group.slug] = true; break; }
        }
      });

      function applyCollapse() {
        item.modifierGroups.forEach(function (group) {
          if (group.options.length <= COLLAPSE_N) { return; }
          var fs = body.querySelector('fieldset[data-group-fs="' + group.slug + '"]');
          if (!fs) { return; }
          var expanded = !!collapseState[group.slug];
          var opts = fs.querySelectorAll('.roc__mg-option');
          var hidden = 0, i;
          for (i = 0; i < opts.length; i++) {
            var inp2 = opts[i].querySelector('input');
            var checked = !!(inp2 && inp2.checked);
            var vis = expanded || i < COLLAPSE_N || checked;
            opts[i].hidden = !vis;
            if (!vis) { hidden++; }
          }
          var toggle = fs.querySelector('[data-group-toggle="' + group.slug + '"]');
          if (!toggle) { return; }
          if (expanded) {
            toggle.hidden = false;
            toggle.textContent = t(settings, 'modifierShowLess', 'Weniger anzeigen');
            toggle.setAttribute('aria-expanded', 'true');
          } else if (hidden > 0) {
            toggle.hidden = false;
            toggle.textContent = t(settings, 'modifierShowMore', 'Weitere %s anzeigen').replace('%s', String(hidden));
            toggle.setAttribute('aria-expanded', 'false');
          } else {
            toggle.hidden = true;
          }
        });
      }

      function applyGroupCaps() {
        item.modifierGroups.forEach(function (group) {
          var max = Number(group.maxSelect || 0);
          if (group.type !== 'multiple' || max <= 0) { return; }
          var inputs = body.querySelectorAll('input[type="checkbox"][data-group="' + group.slug + '"]');
          var checked = 0, i;
          for (i = 0; i < inputs.length; i++) { if (inputs[i].checked) { checked++; } }
          var atMax = checked >= max;
          for (i = 0; i < inputs.length; i++) { inputs[i].disabled = atMax && !inputs[i].checked; }
          var fs = body.querySelector('fieldset[data-group-fs="' + group.slug + '"]');
          if (fs) { var note = fs.querySelector('.roc__mg-maxnote'); if (note) { note.hidden = !atMax; } }
        });
      }

      function clearGroupHighlight() {
        var hl = body.querySelectorAll('.roc__mg-group.roc__validation-highlight');
        Array.prototype.forEach.call(hl, function (n) { n.classList.remove('roc__validation-highlight'); });
      }
      function highlightGroup(slug) {
        clearGroupHighlight();
        var fs = body.querySelector('fieldset[data-group-fs="' + slug + '"]');
        if (!fs) { return; }
        fs.classList.add('roc__validation-highlight');
        try { fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (e) { try { fs.scrollIntoView(); } catch (e2) {  } }
      }
      function refresh() {
        var picked = collectSelection(item, body);
        priceEl.textContent = money(Number(item.price || 0) + picked.deltaCents / 100, settings.currency);
        err.textContent = '';
        clearGroupHighlight();
        applyGroupCaps();
        applyCollapse();
        for (var dp = 0; dp < dynamicPrices.length; dp++) {
          dynamicPrices[dp].span.textContent = optionPriceText(dynamicPrices[dp].opt, body);
        }
      }
      body.onchange = refresh;
      refresh();
      addBtn.onclick = function () {
        if (!hasModifierGroups(item)) {

          var pid = String(item.id);
          state.cart[pid] = state.cart[pid] || 0;
          var was = state.cart[pid];
          state.cart[pid] = Math.min(limit, state.cart[pid] + 1);
          if (state.cart[pid] > was) { showAddedToast(); }
          state.idempotencyKey = null;
          closeConfigurator();
          update();
          persistCart();
          return;
        }
        var problem = selectionError(item, body);
        if (problem) { err.textContent = problem.message; highlightGroup(problem.slug); return; }
        var picked = collectSelection(item, body);
        addConfigured(item, picked);
        closeConfigurator();
        update();
        persistCart();
      };
      modal.hidden = false;
      root.classList.add('roc--modal-open');
    }

    function addConfigured(item, picked) {
      var key = configKey(item.id, picked.selection);
      var existing = state.configuredCart[key];
      var unit = Number(item.price || 0) + picked.deltaCents / 100;
      if (existing) {
        existing.qty = Math.min(limit, existing.qty + 1);
      } else {
        state.configuredCart[key] = {
          id: parseInt(item.id, 10),
          qty: 1,
          modifiers: picked.selection,
          displayName: item.name,
          optionLabels: picked.labels,
          unitDisplayPrice: unit,
          unitDisplayPriceCents: (parseInt(item.priceCents, 10) || 0) + (picked.deltaCents | 0)
        };
      }
      state.idempotencyKey = null;
    }

    function configuredQtyFor(productId) {
      var total = 0;
      Object.keys(state.configuredCart).forEach(function (key) {
        var line = state.configuredCart[key];
        if (line && String(line.id) === String(productId)) total += line.qty;
      });
      return total;
    }

    function cartHasItems() {
      var simple = Object.keys(state.cart).some(function (id) { return state.cart[id] > 0; });
      var configured = Object.keys(state.configuredCart || {}).some(function (key) {
        var line = state.configuredCart[key];
        return line && line.qty > 0;
      });
      return simple || configured;
    }

    var groups = groupByCategory(items, t(settings, 'fallbackCategory', 'Speisen'));
    var openNow = isOpen(settings);

    var canOrder = hasType && (hasNumber || hasServer);

    var todayMode = specialDayMode(settings, todayStr);
    var todayClosed = todayMode === 'closed';
    var todayDeliveryAllowed = serviceAllowedOnDate(settings, todayStr, 'delivery');
    var todayPickupAllowed = serviceAllowedOnDate(settings, todayStr, 'pickup');
    var openNowEffective = openNow && !todayClosed;

    var hasPhone = !!(settings.restaurantPhone && String(settings.restaurantPhone).length);
    var hasMail = !!settings.restaurantEmailSet;
    var nowParts = getZonedParts(settings.timezone);
    function openNowMap(hours) { return availableAt(hours || {}, nowParts.day, nowParts.minutes); }

    var deliveryNow = !!settings.deliveryEnabled && openNowEffective && todayDeliveryAllowed && openNowMap(settings.hoursDelivery);
    var pickupNow = !!settings.pickupEnabled && openNowEffective && todayPickupAllowed && openNowMap(settings.hoursTakeaway);
    var typeNow = deliveryNow || pickupNow;

    var phoneTodayAllowed = openNowEffective && (todayDeliveryAllowed || todayPickupAllowed);

    var telUrl = hasPhone ? ('tel:' + String(settings.restaurantPhone).replace(/[^\d+]/g, '')) : '';

    var headerMain = openNowEffective ? t(settings, 'open', 'Jetzt offen') : t(settings, 'closed', 'Geschlossen');
    var headerDetail = '';
    if (openNowEffective) {
      var hdrEnd = currentAvailabilityEnd(settings, 'open', todayStr, nowParts.minutes);
      if (hdrEnd !== null) headerDetail = fmt1(t(settings, 'badgeOpenUntil', 'bis %s Uhr'), endLabel(settings, hdrEnd));
    } else {
      var hdrNext = nextOpenMoment(settings);
      if (hdrNext) headerDetail = fmt2(t(settings, 'badgeOpensDayAt', 'oeffnet %1$s ab %2$s'), relDay(settings, hdrNext.date), formatMinutes(hdrNext.minutes));
    }
    var headerBadgeKids = headerDetail
      ? [el('span', { 'class': 'roc__badge-main' }, [headerMain]), el('span', { 'class': 'roc__badge-detail' }, [headerDetail])]
      : [headerMain];
    var headerBadge = el('button', { type: 'button', 'class': 'roc__badge roc__badge--btn ' + (openNowEffective ? 'is-open' : 'is-closed'), 'aria-label': (headerDetail ? headerMain + ' ' + headerDetail : headerMain) }, headerBadgeKids);
    headerBadge.addEventListener('click', function () { openStatusModal(); });

    var headerAside = [headerBadge];
    if (settings.locales && settings.locales.mode === 'selector' && settings.i18nByLocale) {
      headerAside.push(rocBuildLangSwitcher(settings, customerLocale, root, data));
    }
    var header = el('div', { 'class': 'roc__header' }, [
      el('div', null, [
        el('h2', null, [t(settings, 'heading', 'Online bestellen')]),
        el('p', null, [t(settings, 'intro', '')])
      ]),
      el('div', { 'class': 'roc__header-aside' }, headerAside)
    ]);

    function cbadge(label, st, iconName) {

      var full = st.detail ? (label + ': ' + st.detail) : label;
      var pop = el('span', { 'class': 'roc__cbadge-pop', role: 'tooltip', hidden: true }, [full]);
      var btn = el('button', { type: 'button', 'class': 'roc__cbadge ' + st.cls, 'aria-label': full }, [
        icon(iconName),
        st.detail ? el('span', { 'class': 'roc__cbadge-detail' }, [st.detail]) : null,
        pop
      ]);
      btn.addEventListener('mouseenter', function () { pop.hidden = false; });
      btn.addEventListener('mouseleave', function () { pop.hidden = true; });
      btn.addEventListener('click', function () { pop.hidden = true; openStatusModal(); });
      return btn;
    }

    function svcBadge(type, nowFlag) {
      var nxt = nextBookableSlot(settings, type);
      if (nowFlag && nxt && nxt.date === todayStr) {
        var end = currentAvailabilityEnd(settings, type, todayStr, nowParts.minutes);
        return { cls: 'is-now', detail: end !== null ? fmt1(t(settings, 'badgeNowUntil', 'jetzt bis %s Uhr'), endLabel(settings, end)) : '' };
      }
      if (nxt) return { cls: 'is-preorder', detail: fmt1(t(settings, 'badgePreorderFrom', 'Vorbestellung ab %s'), slotLabel(settings, nxt)) };
      return { cls: 'is-none', detail: t(settings, 'badgeNoSlot', 'derzeit keine Zeit verfuegbar') };
    }

    var phoneSt;
    if (phoneTodayAllowed) {
      var phEnd = currentAvailabilityEnd(settings, 'open', todayStr, nowParts.minutes);
      phoneSt = { cls: 'is-now', detail: phEnd !== null ? fmt1(t(settings, 'badgePhoneUntil', 'bis %s erreichbar'), endLabel(settings, phEnd)) : '' };
    } else {
      var phNext = nextOpenMoment(settings);
      phoneSt = phNext ? { cls: 'is-preorder', detail: fmt1(t(settings, 'badgeFrom', 'ab %s'), slotLabel(settings, phNext)) } : { cls: 'is-none', detail: t(settings, 'badgeNoSlot', 'derzeit keine Zeit verfuegbar') };
    }

    var badgeData = [];
    if (hasServer) {
      if (settings.deliveryEnabled) badgeData.push({ label: t(settings, 'delivery', 'Lieferung'), st: svcBadge('delivery', deliveryNow), iconName: 'delivery' });
      if (settings.pickupEnabled) badgeData.push({ label: t(settings, 'pickup', 'Abholung'), st: svcBadge('pickup', pickupNow), iconName: 'pickup' });

      if (hasNumber) badgeData.push({ label: t(settings, 'badgeWhatsapp', 'WhatsApp'), st: { cls: 'is-now', detail: t(settings, 'badgeWhatsappReady', 'Bestellung moeglich') }, iconName: 'chat' });
      if (hasPhone) badgeData.push({ label: t(settings, 'badgePhone', 'Telefonisch'), st: phoneSt, iconName: 'phone' });
      if (hasMail) badgeData.push({ label: t(settings, 'email', 'E-Mail'), st: { cls: 'is-now', detail: t(settings, 'badgeMailReady', 'jederzeit moeglich') }, iconName: 'mail' });
    }
    var badgeNodes = badgeData.map(function (d) { return cbadge(d.label, d.st, d.iconName); });
    var badges = badgeNodes.length ? el('div', { 'class': 'roc__badges' }, badgeNodes) : null;

    function openStatusModal() {
      var modal = root.querySelector('[data-status-modal]');
      if (!modal) { return; }
      var body = modal.querySelector('[data-status-body]');
      body.textContent = '';
      var biz = (data && data.settings && data.settings.business) ? data.settings.business : {};
      var logoUrl = (data && data.settings && data.settings.siteLogo) ? data.settings.siteLogo : '';
      if (logoUrl) { body.appendChild(el('div', { 'class': 'roc__status-logo' }, [el('img', { src: logoUrl, alt: biz.name || '', loading: 'lazy' })])); }
      var info = [];
      if (biz.name) { info.push(el('div', { 'class': 'roc__status-name' }, [biz.name])); }
      if (biz.street && String(biz.street).trim()) { info.push(el('div', { 'class': 'roc__status-line' }, [biz.street])); }
      var cityLine = ((biz.postcode || '') + ' ' + (biz.city || '')).replace(/\s+/g, ' ').trim();
      if (cityLine) { info.push(el('div', { 'class': 'roc__status-line' }, [cityLine])); }

      var contact = [];
      if (biz.phone && String(biz.phone).trim()) {
        contact.push(el('a', { 'class': 'roc__status-contact-link', href: 'tel:' + String(biz.phone).replace(/[^0-9+]/g, '') }, [biz.phone]));
      }
      if (biz.email && String(biz.email).trim()) {
        contact.push(el('a', { 'class': 'roc__status-contact-link', href: 'mailto:' + biz.email }, [biz.email]));
      }
      if (contact.length) { info.push(el('div', { 'class': 'roc__status-contact' }, contact)); }
      if (info.length) { body.appendChild(el('div', { 'class': 'roc__status-info' }, info)); }
      body.appendChild(el('hr', { 'class': 'roc__status-hr' }));
      var openTxt = headerDetail ? (headerMain + ' ' + headerDetail) : headerMain;
      body.appendChild(el('p', { 'class': 'roc__status-open ' + (openNowEffective ? 'is-open' : 'is-closed') }, [openTxt]));
      badgeData.forEach(function (d) {
        var txt = d.st.detail ? (d.label + ' ' + d.st.detail) : d.label;
        body.appendChild(el('div', { 'class': 'roc__status-row ' + (d.st.cls || '') }, [icon(d.iconName), el('span', { 'class': 'roc__status-row-txt' }, [txt])]));
      });
      modal.hidden = false;
      root.classList.add('roc--modal-open');
    }
    function closeStatusModal() {
      var modal = root.querySelector('[data-status-modal]');
      if (modal) { modal.hidden = true; }
      root.classList.remove('roc--modal-open');
    }

    function openLegendModal() {
      var modal = root.querySelector('[data-legend-modal]');
      if (!modal) { return; }
      modal.hidden = false;
      root.classList.add('roc--modal-open');
    }
    function closeLegendModal() {
      var modal = root.querySelector('[data-legend-modal]');
      if (modal) { modal.hidden = true; }
      root.classList.remove('roc--modal-open');
    }

    var notices = [];
    if (!openNowEffective) notices.push(el('div', { 'class': 'roc__notice' }, [settings.closedMessage || t(settings, 'closed', 'Geschlossen')]));
    if (!hasType) notices.push(el('div', { 'class': 'roc__notice' }, [t(settings, 'noOrderType', 'Aktuell ist weder Abholung noch Lieferung aktiviert.')]));
    if (!hasNumber && !hasServer) notices.push(el('div', { 'class': 'roc__notice' }, [t(settings, 'noNumber', 'Keine WhatsApp-Nummer hinterlegt.')]));
    if (!items.length) notices.push(el('div', { 'class': 'roc__notice' }, [t(settings, 'noItems', 'Noch keine Menue-Eintraege erfasst.')]));

    var baseNames = Object.keys(groups);
    var orderPref = (settings.categoryOrder && settings.categoryOrder.length) ? settings.categoryOrder : [];
    var categoryNames = [];
    var seenCat = {};
    orderPref.forEach(function (name) {
      if (Object.prototype.hasOwnProperty.call(groups, name) && !seenCat[name]) { categoryNames.push(name); seenCat[name] = true; }
    });
    baseNames.forEach(function (name) {
      if (!seenCat[name]) { categoryNames.push(name); seenCat[name] = true; }
    });
    var catIcons = settings.categoryIcons || {};

    var itemCatIcon = {};

    var catI18n = settings.categoryI18n || {};
    function catDisplay(category) {
      var e = catI18n[category];
      return (e && typeof e[customerLocale] === 'string' && e[customerLocale] !== '') ? e[customerLocale] : category;
    }

    function catLabel(category, extraIconClass) {
      var ci = catIcons[category];
      var label = catDisplay(category);
      if (ci && ci.url) {

        return [el('img', { 'class': 'roc__caticon' + (extraIconClass ? ' ' + extraIconClass : ''), src: ci.url, alt: ci.alt || '', loading: 'lazy', decoding: 'async', width: String(ci.width || 32), height: String(ci.height || 32) }), label];
      }
      return [label];
    }

    var menuDiscountAllowed = rocDiscountDisplayAllowed(data);
    var menuRules = (data && data.discounts) || [];
    function itemDiscountBadges(item) {
      if (!menuDiscountAllowed) return null;
      var matches = rocDiscountBadgesForItem(item, menuRules);
      if (!matches.length) return null;
      var nodes = matches.slice(0, 2).map(function (r) {
        return el('span', { 'class': 'roc__discount-badge' }, [discountLabel(r, customerLocale) || t(settings, 'discountAvailable', 'Rabatt verfuegbar')]);
      });
      if (matches.length > 2) {
        nodes.push(el('span', { 'class': 'roc__discount-badge roc__discount-badge--more' }, ['+' + (matches.length - 2)]));
      }
      return el('div', { 'class': 'roc__discount-badges' }, nodes);
    }

    function hintIcon(slug) {
      var info = (settings.productIcons || {})[slug];
      var label = iconLabel(settings, slug);
      if (!info || !label) return null;

      return el('span', {
        'class': 'roc__hint' + (info.cssClass ? ' ' + info.cssClass : ''),
        title: label,
        'data-legend-open': settings.productIconLegendEnabled ? '' : null
      }, [
        el('span', { 'class': 'roc__hint-txt' }, [label])
      ]);
    }

    function hintIconRow(item, extraClass) {
      var slugs = (item && Array.isArray(item.icons)) ? item.icons : [];
      var nodes = [];
      for (var i = 0; i < slugs.length; i++) {
        var node = hintIcon(slugs[i]);
        if (node) nodes.push(node);
      }
      if (!nodes.length) return null;
      return el('span', { 'class': 'roc__hints' + (extraClass ? ' ' + extraClass : '') }, nodes);
    }

    function usedLegendSlugs() {
      if (!settings.productIconLegendEnabled) return [];
      var map = settings.productIcons || {};
      var used = {};
      for (var i = 0; i < items.length; i++) {
        var ic = items[i] && items[i].icons;
        if (Array.isArray(ic)) { for (var j = 0; j < ic.length; j++) { used[ic[j]] = true; } }
      }
      return Object.keys(map).filter(function (slug) { return used[slug] && map[slug] && map[slug].label; });
    }

    var allergenFallback = 'Informationen über Zutaten in unseren Gerichten, die Allergene und/oder Intoleranzen auslösen können, erhalten Sie von unseren Mitarbeitern auf Anfrage.';

    function buildHintLegend() {
      if (!settings.productIconLegendEnabled) return null;
      return el('div', { 'class': 'roc__menu-info' }, [
        el('p', { 'class': 'roc__menu-info-allergen' }, [t(settings, 'allergenInfo', allergenFallback)]),
        el('p', { 'class': 'roc__menu-info-price' }, [t(settings, 'priceVatNote', 'Alle Preise in CHF und inkl. MWST.')])
      ]);
    }

    function buildLegendModal() {
      var slugs = usedLegendSlugs();
      if (!slugs.length) return null;
      var map = settings.productIcons || {};
      var rows = slugs.map(function (slug) {
        var info = map[slug];
        return el('div', { 'class': 'roc__legend-item' }, [
          el('span', { 'class': 'roc__hint roc__legend-ico' + (info.cssClass ? ' ' + info.cssClass : ''), 'aria-hidden': 'true' }),
          el('span', { 'class': 'roc__legend-label' }, [iconLabel(settings, slug) || info.label])
        ]);
      });
      return el('div', { 'class': 'roc__modal', 'data-legend-modal': '', hidden: true }, [
        el('div', { 'class': 'roc__modal-box roc__mg-box roc__legend-modal-box', role: 'dialog', 'aria-modal': 'true', 'aria-label': t(settings, 'iconLegendTitle', 'Hinweis-Symbole') }, [
          el('h3', { 'class': 'roc__modal-title roc__legend-modal-title' }, [t(settings, 'iconLegendTitle', 'Hinweis-Symbole')]),
          el('div', { 'class': 'roc__legend-list', 'data-legend-body': '' }, rows),
          el('p', { 'class': 'roc__legend-note' }, [t(settings, 'allergenInfo', allergenFallback)]),
          el('div', { 'class': 'roc__mg-foot roc__status-foot' }, [
            el('button', { type: 'button', 'class': 'roc__modal-close roc__mg-add', 'data-legend-close': '' }, [t(settings, 'confirmClose', 'Schliessen')])
          ])
        ])
      ]);
    }
    function categoryDiscountNote(catItems) {
      if (!menuDiscountAllowed) return null;
      var ids = {};
      catItems.forEach(function (it) { (it.categoryIds || []).forEach(function (c) { ids[c] = 1; }); });
      var hit = null;
      menuRules.forEach(function (rule) {
        if (hit || rule.scope !== 'category') return;
        (rule.targetCategoryIds || []).forEach(function (c) { if (!hit && ids[c]) hit = rule; });
      });
      if (!hit) return null;
      return el('p', { 'class': 'roc__discount-note roc__discount-note--category' }, [discountLabel(hit, customerLocale) || t(settings, 'discountAvailable', 'Rabatt verfuegbar')]);
    }
    var categorySections = categoryNames.map(function (category, index) {
      var headerNodes = [el('h3', null, catLabel(category, 'roc__caticon--section'))];
      var catNote = categoryDiscountNote(groups[category]);
      if (catNote) headerNodes.push(catNote);

      var sectionAttrs = { 'class': 'roc__category', 'data-category-index': String(index) };
      if (index !== 0) { sectionAttrs.hidden = true; }
      var section = el('section', sectionAttrs, headerNodes.concat(
        groups[category].map(function (item) {
          if (catIcons[category] && (catIcons[category].url || catIcons[category].popup) && !itemCatIcon[item.id]) { itemCatIcon[item.id] = catIcons[category]; }

          var openAttrs = { 'data-product-open': String(item.id), role: 'button', tabindex: '0', 'aria-label': fmt1(t(settings, 'productDetails', 'Details zu %s anzeigen'), item.name) };
          return el('article', { 'class': 'roc__item' + (item.image && item.image.thumb ? ' roc__item--has-img' : ''), 'data-id': String(item.id) }, [

            item.image && item.image.thumb ? el('img', mergeAttrs({ 'class': 'roc__item-img roc__item-open', src: item.image.thumb, alt: item.image.alt || item.name, loading: 'lazy', decoding: 'async', width: String(item.image.width || 192), height: String(item.image.height || 192) }, openAttrs), null) : null,
            el('div', null, [
              el('strong', mergeAttrs({ 'class': 'roc__item-open' }, openAttrs), [item.name]),

              item.description ? el('p', mergeAttrs({ 'class': 'roc__desc roc__item-open', rich: item.description }, openAttrs), null) : null,
              item.note ? el('small', null, [item.note]) : null,
              itemDiscountBadges(item),
              hintIconRow(item, 'roc__hints--card')
            ]),
            el('div', { 'class': 'roc__item-actions' }, [
              el('span', null, [money(item.price, settings.currency)]),
              el('button', { type: 'button', 'data-action': 'dec', 'aria-label': t(settings, 'decOne', '1 weniger'), title: t(settings, 'decOne', '1 weniger') }, ['-']),
              el('b', { 'data-qty': String(item.id) }, ['0']),
              el('button', { type: 'button', 'data-action': 'inc', 'aria-label': t(settings, 'incOne', '1 mehr'), title: t(settings, 'incOne', '1 mehr') }, ['+'])
            ])
          ]);
        })
      ));
      return section;
    });
    var catnav = null;
    if (categoryNames.length) {

      var hasAll = categoryNames.length > 1;
      var trackButtons = [];
      if (hasAll) {
        trackButtons.push(el('button', { type: 'button', 'class': 'roc__catbtn', 'data-cat-target': 'all' }, [t(settings, 'showAll', 'Alle')]));
      }
      categoryNames.forEach(function (category, index) {
        trackButtons.push(el('button', { type: 'button', 'class': 'roc__catbtn' + (index === 0 ? ' is-active' : ''), 'data-cat-target': String(index) }, catLabel(category)));
      });
      var catTrack = el('div', { 'class': 'roc__catnav-track', 'data-catnav-track': '' }, trackButtons);
      catnav = el('div', { 'class': 'roc__catnav' }, [
        el('button', { type: 'button', 'class': 'roc__catarrow', 'data-cat-arrow': 'prev', 'aria-label': '\u2039', hidden: true }, ['\u2039']),
        catTrack,
        el('button', { type: 'button', 'class': 'roc__catarrow', 'data-cat-arrow': 'next', 'aria-label': '\u203A', hidden: true }, ['\u203A'])
      ]);
    }
    var hintLegend = buildHintLegend();
    var menu = el('div', { 'class': 'roc__menu' }, [el('p', { 'class': 'roc__fielderror', 'data-error': 'cart', hidden: true })].concat(catnav ? [catnav] : []).concat(categorySections).concat(hintLegend ? [hintLegend] : []));

    var deliverySlot = settings.deliveryEnabled ? nextBookableSlot(settings, 'delivery') : null;
    var pickupSlot = settings.pickupEnabled ? nextBookableSlot(settings, 'pickup') : null;
    var deliveryBookable = !settings.deliveryEnabled || !!deliverySlot;
    var pickupBookable = !settings.pickupEnabled || !!pickupSlot;
    var gatedMsgs = [];
    if (settings.pickupEnabled && !pickupBookable) gatedMsgs.push(t(settings, 'pickupNotBookable', 'Abholung derzeit nicht verfuegbar.'));
    if (settings.deliveryEnabled && !deliveryBookable) gatedMsgs.push(t(settings, 'deliveryNotBookable', 'Lieferung derzeit nicht verfuegbar.'));
    var todayMsgs = [];
    if (pickupSlot && pickupSlot.date !== todayStr) todayMsgs.push(t(settings, 'pickup', 'Abholung') + ': ' + fmt1(t(settings, 'badgePreorderFrom', 'Vorbestellung ab %s'), slotLabel(settings, pickupSlot)));
    if (deliverySlot && deliverySlot.date !== todayStr) todayMsgs.push(t(settings, 'delivery', 'Lieferung') + ': ' + fmt1(t(settings, 'badgePreorderFrom', 'Vorbestellung ab %s'), slotLabel(settings, deliverySlot)));
    var typeRadios = el('div', { 'class': 'roc__types roc__types--cards' }, [
      settings.pickupEnabled ? el('label', { 'class': 'roc__type-card' + (pickupBookable ? '' : ' roc__type-card--disabled') }, [
        el('input', { type: 'radio', name: 'type-' + root.id, value: 'pickup', checked: state.type === 'pickup' && pickupBookable, disabled: !pickupBookable }),
        icon('pickup'),
        el('span', { 'class': 'roc__type-card-txt' }, [t(settings, 'pickup', 'Abholung')])
      ]) : null,
      settings.deliveryEnabled ? el('label', { 'class': 'roc__type-card' + (deliveryBookable ? '' : ' roc__type-card--disabled') }, [
        el('input', { type: 'radio', name: 'type-' + root.id, value: 'delivery', checked: state.type === 'delivery' && deliveryBookable, disabled: !deliveryBookable }),
        icon('delivery'),
        el('span', { 'class': 'roc__type-card-txt' }, [t(settings, 'delivery', 'Lieferung')])
      ]) : null
    ]);
    var types = el('div', { 'class': 'roc__typegroup', 'data-fieldgroup': 'type', tabindex: '-1' }, [
      typeRadios,
      gatedMsgs.length ? el('p', { 'class': 'roc__warning', 'data-type-gated': '' }, [gatedMsgs.join(' ')]) : null,
      todayMsgs.length ? el('p', { 'class': 'roc__warning', 'data-type-today': '' }, [todayMsgs.join(' \u00b7 ')]) : null,
      el('p', { 'class': 'roc__warning', 'data-special-notice': '', hidden: true }),
      el('p', { 'class': 'roc__fielderror', 'data-error': 'type', hidden: true })
    ]);

    var firstNameInput = el('input', { 'data-field': 'firstName', name: 'given-name', autocomplete: 'given-name', required: true, placeholder: t(settings, 'firstName', 'Vorname') });
    var lastNameInput = el('input', { 'data-field': 'lastName', name: 'family-name', autocomplete: 'family-name', required: true, placeholder: t(settings, 'lastName', 'Nachname') });
    var phoneInput = el('input', { 'data-field': 'phone', type: 'tel', name: 'tel', autocomplete: 'tel', inputmode: 'tel', required: true, placeholder: t(settings, 'phone', 'Telefon') });
    var contactError = el('p', { 'class': 'roc__fielderror', 'data-error': 'contact', hidden: true });
    var emailInput = hasServer ? el('input', { 'data-field': 'email', type: 'email', name: 'email', autocomplete: 'email', autocapitalize: 'none', spellcheck: 'false', placeholder: t(settings, 'email', 'E-Mail') }) : null;
    var emailError = hasServer ? el('p', { 'class': 'roc__fielderror', 'data-error': 'email', hidden: true }) : null;
    var deliveryFieldsNode = el('div', { 'data-delivery-fields': '' }, [
      el('input', { 'data-field': 'street', name: 'street-address', autocomplete: 'street-address', placeholder: t(settings, 'street', 'Strasse & Nr.') }),

      el('div', { 'class': 'roc__addr-hint', 'data-addr-hint': '', hidden: true }),
      el('p', { 'class': 'roc__fielderror', 'data-error': 'address', hidden: true }),
      el('div', { 'class': 'roc__row' }, [
        el('input', { 'data-field': 'zip', name: 'postal-code', autocomplete: 'postal-code', inputmode: 'numeric', placeholder: t(settings, 'zip', 'PLZ') }),
        el('input', { 'data-field': 'city', name: 'address-level2', autocomplete: 'address-level2', placeholder: t(settings, 'city', 'Ort') })
      ]),

      el('div', { 'class': 'roc__delivery-feedback', 'data-delivery-feedback': '', hidden: true })
    ]);

    var timeRow = el('div', { 'class': 'roc__row2' }, [
      el('label', { 'class': 'roc__field' }, [
        el('span', { 'class': 'roc__fieldlabel' }, [icon('calendar'), el('span', { 'class': 'roc__fieldlabel-txt' }, [t(settings, 'dateLabel', 'Datum')])]),
        el('input', { type: 'date', 'data-field': 'date', name: 'roc-date', min: todayStr, max: maxDateStr, required: true })
      ]),
      el('label', { 'class': 'roc__field' }, [
        el('span', { 'class': 'roc__fieldlabel' }, [icon('clock'), el('span', { 'class': 'roc__fieldlabel-txt', 'data-time-label': '' }, [t(settings, 'pickupTime', 'Abholzeit')])]),

        el('select', { 'data-field': 'time', name: 'roc-time', 'class': 'roc__timeselect', required: true, disabled: true }, [
          el('option', { value: '' }, [t(settings, 'slotPickHint', 'Bitte zuerst Bestellart und Datum waehlen')])
        ])
      ])
    ]);

    var calendarNode = el('div', { 'class': 'roc-calendar', 'data-roc-calendar': '' });
    var slotError = el('p', { 'class': 'roc__fielderror', 'data-error': 'slot', hidden: true });
    var commentNode = el('textarea', { 'data-field': 'comment', name: 'roc-comment', placeholder: t(settings, 'comment', 'Bemerkung') });

    var honeypotNode = el('div', { 'aria-hidden': 'true', style: 'position:absolute;left:-9999px;top:auto;width:1px;height:1px;overflow:hidden' }, [
      el('label', null, [
        'Website',
        el('input', { 'data-field': 'website', type: 'text', name: 'roc-extra', tabindex: '-1', autocomplete: 'off', value: '' })
      ])
    ]);

    var captchaProvider = (settings.captchaProvider && settings.captchaProvider !== 'none') ? settings.captchaProvider : '';

    var captchaBox = (captchaProvider && settings.captchaSiteKey)
      ? el('div', { 'class': 'roc__captcha-group', 'data-fieldgroup': 'captcha', tabindex: '-1' }, [
          el('div', { 'class': (captchaProvider === 'turnstile' ? 'cf-turnstile' : 'g-recaptcha') + ' roc__captcha', 'data-sitekey': settings.captchaSiteKey }),
          el('p', { 'class': 'roc__fielderror', 'data-error': 'captcha', hidden: true })
        ])
      : null;

    var submitButtons;
    var hasOrderButtons = false;

    var todayBlockedWithoutDate = todayClosed && !String(state.date || '').trim();
    if (!hasServer) {
      submitButtons = [
        el('button', { type: 'button', 'class': 'roc__whatsapp', 'data-channel': 'whatsapp', disabled: !canOrder || todayBlockedWithoutDate }, [t(settings, 'whatsappButton', 'via WhatsApp')])
      ];
      hasOrderButtons = true;
    } else {
      submitButtons = [];
      if (hasNumber) submitButtons.push(el('button', { type: 'button', 'data-channel': 'whatsapp', disabled: !canOrder || todayBlockedWithoutDate }, [t(settings, 'whatsappButton', 'via WhatsApp')]));
      if (hasMail) submitButtons.push(el('button', { type: 'button', 'data-channel': 'mail', disabled: !canOrder || todayBlockedWithoutDate }, [t(settings, 'mailButton', 'via E-Mail')]));
      if (hasPhone) submitButtons.push(el('button', { type: 'button', 'data-channel': 'phone', disabled: !canOrder || !phoneTodayAllowed }, [t(settings, 'phoneButton', 'via Telefon')]));
      hasOrderButtons = submitButtons.length > 0;
      submitButtons.forEach(function (btn, i) { btn.className = i === 0 ? 'roc__whatsapp' : 'roc__channelbtn'; });

      if (!submitButtons.length) {
        submitButtons.push(el('p', { 'class': 'roc__warning', 'data-channel-missing': '' }, [t(settings, 'noChannel', 'Aktuell ist keine Online-Bestellung moeglich: kein Bestellkanal eingerichtet.')]));
      }
    }

    var paymentMethods = [];
    if (settings.paymentCashEnabled) paymentMethods.push(['cash_on_delivery', t(settings, 'paymentCash', 'Bar'), t(settings, 'paymentCashDesc', 'Bei Abholung oder Lieferung bar bezahlen.')]);
    if (settings.paymentCardEnabled) paymentMethods.push(['card_on_delivery', t(settings, 'paymentCard', 'Karte'), t(settings, 'paymentCardDesc', 'Bei Abholung oder Lieferung mit Karte bezahlen.')]);
    if (settings.paymentOnlineEnabled) paymentMethods.push(['online_payment', t(settings, 'paymentOnline', 'Jetzt online zahlen'), t(settings, 'paymentOnlineDesc', 'Nach dem Absenden direkt online bezahlen.')]);
    var paymentValues = paymentMethods.map(function (m) { return m[0]; });

    if (state.paymentMethod && paymentValues.indexOf(state.paymentMethod) === -1) { state.paymentMethod = ''; }
    var paymentBlock = (hasServer && paymentMethods.length)
      ? el('div', { 'class': 'roc__payment', 'data-payment': '', tabindex: '-1' }, [
          el('p', { 'class': 'roc__payment-title' }, [t(settings, 'paymentTitle', 'Zahlungsart waehlen')])
        ].concat(paymentMethods.map(function (m) {
          return el('label', { 'class': 'roc__payment-option' }, [
            el('input', { type: 'radio', name: 'roc-payment', 'data-field': 'paymentMethod', value: m[0], checked: state.paymentMethod === m[0] }),
            icon(m[0] === 'online_payment' ? 'lock' : (m[0] === 'card_on_delivery' ? 'card' : 'cash')),
            el('span', { 'class': 'roc__payment-text' }, [
              el('span', { 'class': 'roc__payment-label' }, [m[1]]),
              el('span', { 'class': 'roc__payment-desc' }, [m[2]])
            ])
          ]);
        })).concat([el('p', { 'class': 'roc__fielderror', 'data-error': 'payment', hidden: true })]))
      : null;

    var summaryNode = el('div', { 'class': 'roc__summary', 'data-summary': '' });
    function wizStep(id, titleKey, titleFallback, helpKey, helpFallback, bodyClass, children) {

      var head = [
        el('h4', { 'class': 'roc__wiz-title', 'data-wiz-heading': '', tabindex: '-1' }, [t(settings, titleKey, titleFallback)])
      ];
      if (helpKey) head.push(el('p', { 'class': 'roc__wiz-help' }, [t(settings, helpKey, helpFallback)]));
      return el('div', { 'class': 'roc__wiz-step' + (bodyClass ? ' ' + bodyClass : ''), 'data-step': id, hidden: true }, head.concat(children));
    }
    var stepService = wizStep('service', 'stepServiceTitle', 'Abholung oder Lieferung', 'stepServiceHelp', 'Waehlen Sie, ob Sie abholen oder liefern lassen moechten.', 'roc__fields', [types]);
    var stepAddress = wizStep('address', 'stepAddressTitle', 'Lieferadresse', 'stepAddressHelp', 'Geben Sie zuerst Ihre PLZ ein, damit wir Liefergebiet und Mindestbestellwert pruefen koennen.', 'roc__fields', [deliveryFieldsNode]);
    var stepTime = wizStep('time', 'stepTimeTitle', 'Zeitpunkt', 'stepTimeHelp', 'Waehlen Sie Datum und Zeitfenster.', 'roc__fields', [timeRow, calendarNode, slotError]);
    var stepContact = wizStep('contact', 'stepContactTitle', 'Kontaktdaten', 'stepContactHelp', 'Damit wir Sie bei Rueckfragen erreichen koennen.', 'roc__fields', [firstNameInput, lastNameInput, phoneInput, contactError, emailInput, emailError, honeypotNode]);
    var stepReview = wizStep('review', 'stepReviewTitle', 'Uebersicht', 'stepReviewHelp', 'Pruefen Sie Ihre Bestellung und senden Sie sie ab.', '', [
      summaryNode,
      el('div', { 'class': 'roc__fields' }, [commentNode]),
      captchaBox,
      paymentBlock,
      hasOrderButtons ? el('p', { 'class': 'roc__cta-intro' }, [t(settings, 'orderCtaIntro', 'Bestelle jetzt:')]) : null,
      el('div', { 'class': 'roc__actions' }, submitButtons)
    ]);
    var wizMiniCart = el('div', { 'class': 'roc__wiz-minicart', 'data-wiz-minicart': '', hidden: true }, [
      el('span', { 'class': 'roc__wiz-minicart-count', 'data-wiz-minicart-count': '' }),
      el('span', { 'class': 'roc__wiz-minicart-sum', 'data-wiz-minicart-sum': '' })
    ]);
    var wizChips = el('div', { 'class': 'roc__wiz-chips', 'data-wiz-chips': '' });
    var wizNav = el('div', { 'class': 'roc__wiz-nav', 'data-wiz-nav': '' }, [
      el('button', { type: 'button', 'class': 'roc__wiz-back', 'data-wiz-back': '' }, [t(settings, 'wizBack', 'Zurueck')]),
      el('button', { type: 'button', 'class': 'roc__wiz-next roc__whatsapp', 'data-wiz-next': '' }, [t(settings, 'wizNext', 'Weiter')])
    ]);

    var wizCurrent = 'service';
    var WIZ_STEP_NODES = { service: stepService, address: stepAddress, time: stepTime, contact: stepContact, review: stepReview };
    var WIZ_TITLES = { service: ['stepService', 'Service'], address: ['stepAddress', 'Adresse'], time: ['stepTime', 'Zeit'], contact: ['stepContact', 'Kontakt'], review: ['stepReview', 'Uebersicht'] };

    var WIZ_ICON = { service: 'service', address: 'pin', time: 'clock', contact: 'user', review: 'check' };
    function wizUpdateMiniCart() {
      var countEl = wizMiniCart.querySelector('[data-wiz-minicart-count]');
      var sumEl = wizMiniCart.querySelector('[data-wiz-minicart-sum]');
      if (countEl) countEl.textContent = t(settings, 'cartBarItems', '%1$s Artikel').replace('%1$s', String(lastCartbarCount || 0));
      if (sumEl) sumEl.textContent = money(wizMiniSubtotal || 0, settings.currency);
    }

    function wizGatePasses(seq) {
      return seq.map(function (id) { return rocStepGate(id, state, settings, addrScope) === ''; });
    }
    function wizRender() {
      var seq = rocStepSequence(state.type);
      if (seq.indexOf(wizCurrent) === -1) wizCurrent = seq[0];
      var passes = wizGatePasses(seq);
      var blockIdx = rocStepBlockIndex(passes);
      var curIdx = seq.indexOf(wizCurrent);
      Object.keys(WIZ_STEP_NODES).forEach(function (id) {
        var node = WIZ_STEP_NODES[id];
        if (node) node.hidden = (id !== wizCurrent) || (seq.indexOf(id) === -1);
      });
      wizChips.textContent = '';
      seq.forEach(function (id, i) {
        var reachable = rocStepReachableGated(i, blockIdx, curIdx);
        var cls = 'roc__wiz-chip' + (id === wizCurrent ? ' is-active' : '') + (passes[i] ? ' is-done' : '');
        wizChips.appendChild(el('button', {
          type: 'button',
          'class': cls,
          'data-wiz-chip': id,
          disabled: !reachable,
          'aria-label': t(settings, WIZ_TITLES[id][0], WIZ_TITLES[id][1]),
          'aria-current': id === wizCurrent ? 'step' : null,
          'aria-disabled': !reachable ? 'true' : null
        }, [
          el('span', { 'class': 'roc__wiz-chip-num' }, [String(i + 1)]),
          icon(WIZ_ICON[id] || 'check')
        ]));
      });
      var backBtn = root.querySelector('[data-wiz-back]');
      var nextBtn = root.querySelector('[data-wiz-next]');
      if (backBtn) backBtn.hidden = seq.indexOf(wizCurrent) <= 0;
      if (nextBtn) nextBtn.hidden = wizCurrent === 'review';
      wizUpdateMiniCart();
      wizMiniCart.hidden = wizCurrent === 'review' || lastCartbarCount <= 0;

      if (wizCurrent === 'review' && captchaBox) rocRenderCaptcha(captchaBox, captchaProvider, settings.captchaSiteKey);
    }

    function wizFocusStep() {
      var h = root.querySelector('[data-step="' + wizCurrent + '"] [data-wiz-heading]');
      if (h && typeof h.focus === 'function') { try { h.focus(); } catch (e) {  } }
    }
    function wizGoto(step) {
      var seq = rocStepSequence(state.type);
      if (seq.indexOf(step) === -1) return;
      wizCurrent = step;
      wizRender();
      wizFocusStep();
    }

    function wizNext() {
      var g = rocStepGate(wizCurrent, state, settings, addrScope);
      if (g) {
        var target = rocStepForError(g);
        if (target !== wizCurrent) wizGoto(target);
        reportError(g);
        return;
      }
      wizCurrent = rocStepAdvance(wizCurrent, state.type);
      wizRender();
      wizFocusStep();
    }
    function wizBack() { wizCurrent = rocStepBack(wizCurrent, state.type); wizRender(); wizFocusStep(); }
    function setupWizard() {
      wizChips.addEventListener('click', function (e) {
        var chip = e.target && e.target.closest ? e.target.closest('[data-wiz-chip]') : null;
        if (!chip) return;
        var id = chip.getAttribute('data-wiz-chip');
        var seq = rocStepSequence(state.type);
        var passes = wizGatePasses(seq);
        if (rocStepReachableGated(seq.indexOf(id), rocStepBlockIndex(passes), seq.indexOf(wizCurrent))) wizGoto(id);
      });
      var backBtn = root.querySelector('[data-wiz-back]');
      var nextBtn = root.querySelector('[data-wiz-next]');
      if (backBtn) backBtn.addEventListener('click', wizBack);
      if (nextBtn) nextBtn.addEventListener('click', wizNext);

      root.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('button[data-channel]') : null;
        if (!btn) return;
        window.setTimeout(function () {
          var errNode = root.querySelector('[data-error]:not([hidden])');
          if (!errNode) return;
          var step = rocStepForError(errNode.getAttribute('data-error'));
          if (step !== wizCurrent) wizGoto(step);
        }, 0);
      });
      wizRender();
    }
    var cart = el('aside', { 'class': 'roc__cart' }, [
      el('h3', null, [t(settings, 'order', 'Bestellung')]),
      wizMiniCart,
      wizChips,
      stepService,
      stepAddress,
      stepTime,
      stepContact,
      stepReview,
      wizNav,
      el('div', { 'class': 'roc__modal', 'data-confirm-modal': '', hidden: true }, [
        el('div', { 'class': 'roc__modal-box', role: 'dialog', 'aria-modal': 'true', 'aria-live': 'polite' }, [
          el('p', { 'class': 'roc__modal-title', 'data-confirm-number': '' }),

          el('p', { 'class': 'roc__modal-text', 'data-confirm-text': '' }, [t(settings, 'orderThanks', 'Danke fuer Ihre Bestellung. Wir verarbeiten Ihren Auftrag so schnell wie moeglich und melden uns bei Bedarf bei Ihnen.')]),
          el('p', { 'class': 'roc__modal-appetit', 'data-confirm-appetit': '' }, [t(settings, 'bonAppetit', 'Bon appetit!')]),
          el('a', { 'class': 'roc__modal-wa', 'data-confirm-wa': '', hidden: true }, [t(settings, 'sendWhatsapp', 'Jetzt per WhatsApp senden')]),
          el('button', { type: 'button', 'class': 'roc__modal-close', 'data-confirm-close': '' }, [t(settings, 'confirmClose', 'Schliessen')])
        ])
      ]),
      el('div', { 'class': 'roc__modal', 'data-live-modal': '', hidden: true }, [
        el('div', { 'class': 'roc__modal-box', role: 'dialog', 'aria-modal': 'true', 'aria-live': 'polite' }, [
          el('p', { 'class': 'roc__modal-title', 'data-live-title': '' }),
          el('p', { 'class': 'roc__modal-text', 'data-live-text': '' }),
          el('p', { 'class': 'roc__modal-text roc__live-countdown', 'data-live-countdown': '', hidden: true }),
          el('a', { 'class': 'roc__modal-close roc__live-call', 'data-live-call': '', href: '#', hidden: true }, [t(settings, 'liveTimeoutCall', 'Telefonisch kontaktieren')]),
          el('button', { type: 'button', 'class': 'roc__modal-close', 'data-live-close': '', hidden: true }, [t(settings, 'confirmClose', 'Schliessen')])
        ])
      ]),
      el('div', { 'class': 'roc__modal', 'data-config-modal': '', hidden: true }, [
        el('div', { 'class': 'roc__modal-box roc__mg-box', role: 'dialog', 'aria-modal': 'true' }, [
          el('div', { 'class': 'roc__mg-scroll' }, [
            el('div', { 'class': 'roc__mg-head', 'data-config-head': '' }, [
              el('img', { 'class': 'roc__mg-img', 'data-config-img': '', alt: '', loading: 'lazy', hidden: true }),
              el('p', { 'class': 'roc__modal-title roc__mg-title', 'data-config-title': '' }),
              el('div', { 'class': 'roc__mg-hints', 'data-config-icons': '', hidden: true })
            ]),
            el('div', { 'class': 'roc__mg-body', 'data-config-body': '' }),
            el('p', { 'class': 'roc__mg-error', 'data-config-error': '', role: 'alert' })
          ]),
          el('div', { 'class': 'roc__mg-foot' }, [
            el('span', { 'class': 'roc__mg-price', 'data-config-price': '' }),
            el('div', { 'class': 'roc__mg-actions' }, [
              el('button', { type: 'button', 'class': 'roc__modal-close roc__mg-cancel', 'data-config-close': '', 'aria-label': t(settings, 'modifierCancel', 'Abbrechen'), title: t(settings, 'modifierCancel', 'Abbrechen') }, [icon('x')]),
              el('button', { type: 'button', 'class': 'roc__modal-close roc__mg-add', 'data-config-add': '' }, [icon('cart'), el('span', { 'class': 'roc__mg-add-txt' }, [t(settings, 'modifierAdd', 'In den Warenkorb')])])
            ])
          ])
        ])
      ]),
      el('div', { 'class': 'roc__modal', 'data-status-modal': '', hidden: true }, [
        el('div', { 'class': 'roc__modal-box roc__mg-box roc__status-modal-box', role: 'dialog', 'aria-modal': 'true', 'aria-label': t(settings, 'statusInfo', 'Status und Erreichbarkeit') }, [
          el('div', { 'class': 'roc__mg-scroll roc__status-scroll', 'data-status-body': '' }),
          el('div', { 'class': 'roc__mg-foot roc__status-foot' }, [
            el('button', { type: 'button', 'class': 'roc__modal-close roc__mg-add', 'data-status-close': '' }, [t(settings, 'confirmClose', 'Schliessen')])
          ])
        ])
      ]),

      buildLegendModal()
    ]);

    var layout = el('div', { 'class': 'roc__layout' }, [menu, cart]);

    root.textContent = '';
    root.appendChild(header);
    if (badges) root.appendChild(badges);
    notices.forEach(function (notice) { root.appendChild(notice); });
    root.appendChild(layout);

    ['[data-confirm-modal]', '[data-live-modal]', '[data-config-modal]', '[data-status-modal]', '[data-legend-modal]'].forEach(function (sel) {
      var m = cart.querySelector(sel);
      if (m) { root.appendChild(m); }
    });

    var cartBar = el('div', { 'class': 'roc__cartbar', 'data-cartbar': '', hidden: true }, [
      el('span', { 'class': 'roc__cartbar-info', 'data-cartbar-info': '' }, [
        icon('cart'),
        el('span', { 'class': 'roc__cartbar-text', 'data-cartbar-text': '' })
      ]),
      el('button', { type: 'button', 'class': 'roc__cartbar-btn', 'data-cartbar-jump': '' }, [t(settings, 'cartBarAction', 'Warenkorb / Bestellen')])
    ]);
    root.appendChild(cartBar);
    root.appendChild(el('div', { 'class': 'roc__toast', 'data-toast': '', role: 'status', 'aria-live': 'polite' }, [t(settings, 'addedToCart', 'Zum Warenkorb hinzugefuegt')]));

    function syncCartbar() {
      var barEl = root.querySelector('[data-cartbar]');
      var show = lastCartbarCount > 0 && !cartPanelVisible;
      if (barEl) barEl.hidden = !show;
      root.classList.toggle('roc--cartbar-visible', show);
    }
    function setupCartbarObserver() {
      var cartPanel = root.querySelector('.roc__cart');
      if (!cartPanel) return;
      if (typeof window.IntersectionObserver === 'function') {
        var obs = new window.IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) { cartPanelVisible = entries[i].isIntersecting; }
          syncCartbar();
        }, { threshold: 0 });
        obs.observe(cartPanel);
        return;
      }

      var recheck = function () {
        var r = cartPanel.getBoundingClientRect();
        var vh = window.innerHeight || (document.documentElement && document.documentElement.clientHeight) || 0;
        cartPanelVisible = r.top < vh && r.bottom > 0;
        syncCartbar();
      };
      rocAddWinListener(rocInstanceId, 'scroll', recheck, { passive: true });
      rocAddWinListener(rocInstanceId, 'resize', recheck);
      recheck();
    }
    setupCartbarObserver();
    setupCategoryNav();
    rebuildTimeSlots();
    buildCalendar();
    setupWizard();
    if (captchaProvider) ensureCaptchaScript(captchaProvider);

    function rebuildTimeSlots() {
      var sel = root.querySelector('[data-field="time"]');
      if (!sel) return;
      var dateStr = String(state.date || '').trim();
      var hasDate = /^\d{4}-\d{2}-\d{2}$/.test(dateStr);
      var hasType = state.type === 'pickup' || state.type === 'delivery';
      var ready = hasDate && hasType;
      var previous = String(state.time || '').trim();

      sel.textContent = '';
      if (!ready) {

        sel.appendChild(el('option', { value: '' }, [t(settings, 'slotPickHint', 'Bitte zuerst Bestellart und Datum waehlen')]));
        sel.disabled = true;
        sel.value = '';
        if (state.time !== '') state.time = '';
        return;
      }

      sel.disabled = false;
      sel.appendChild(el('option', { value: '' }, [t(settings, 'slotPick', 'Zeit waehlen')]));
      var slots = bookableSlotMinutes(settings, state, dateStr);
      if (!slots.length) {

        sel.textContent = '';
        sel.appendChild(el('option', { value: '' }, [t(settings, 'slotUnavailable', 'Fuer diesen Zeitpunkt nehmen wir keine Bestellungen an.')]));
        sel.disabled = true;
        sel.value = '';
        if (state.time !== '') state.time = '';
        return;
      }
      var previousStillValid = false;
      slots.forEach(function (minutes) {
        var hhmm = formatMinutes(minutes);
        if (hhmm === previous) previousStillValid = true;
        sel.appendChild(el('option', { value: hhmm }, [hhmm]));
      });

      if (previousStillValid) {
        sel.value = previous;
        state.time = previous;
      } else {
        sel.value = '';
        if (state.time !== '') state.time = '';
      }
    }

    function setupCategoryNav() {
      var nav = root.querySelector('.roc__catnav');
      if (!nav) return;
      var track = nav.querySelector('[data-catnav-track]');
      var prev = nav.querySelector('[data-cat-arrow="prev"]');
      var next = nav.querySelector('[data-cat-arrow="next"]');
      if (!track) return;
      var buttons = Array.prototype.slice.call(track.querySelectorAll('.roc__catbtn'));
      var sections = Array.prototype.slice.call(root.querySelectorAll('.roc__category'));
      var allMode = false;

      function scrollTrack(left) {

        var maxLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        var clamped = Math.max(0, Math.min(left, maxLeft));
        if (typeof track.scrollTo === 'function') track.scrollTo({ left: clamped, behavior: 'smooth' });
        else track.scrollLeft = clamped;
      }

      function centerInTrack(b) {
        var run = function () {
          var br = b.getBoundingClientRect();
          var tr = track.getBoundingClientRect();
          var delta = (br.left - tr.left) - ((track.clientWidth - b.clientWidth) / 2);
          scrollTrack(track.scrollLeft + delta);
        };
        if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(run);
        else run();
      }

      function updateArrows() {
        if (!prev || !next) return;
        var overflow = (track.scrollWidth - track.clientWidth) > 1;
        if (!overflow) { prev.hidden = true; next.hidden = true; return; }
        prev.hidden = track.scrollLeft <= 1;
        next.hidden = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 1);
      }

      function scrollToActiveTop(target) {
        var sec = (target === 'all') ? sections[0] : sections[parseInt(target, 10)];
        if (!sec) return;
        try { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        catch (e) { try { sec.scrollIntoView(); } catch (e2) {} }
      }

      function activate(btn, scrollToSection, opts) {
        opts = opts || {};
        var doCenter = opts.center !== false;
        var doMeasure = opts.measure !== false;
        var target = btn.getAttribute('data-cat-target');
        buttons.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          if (on && doCenter) {
            centerInTrack(b);
          }
        });
        if (target === 'all') {
          sections.forEach(function (sec) { sec.hidden = false; });
        } else {
          var idx = parseInt(target, 10);
          sections.forEach(function (sec, i) { sec.hidden = i !== idx; });
        }
        allMode = (target === 'all');

        if (allMode) ensureScrollSpy();
        if (doMeasure) {
          updateArrows();
        }
        if (scrollToSection) scrollToActiveTop(target);

        if (allMode) highlightCurrentSection();
      }

      function pillFor(idx) { return track.querySelector('.roc__catbtn[data-cat-target="' + idx + '"]'); }
      function highlightCurrentSection() {
        if (!allMode || !sections.length) return;

        var line;
        if (typeof window.getComputedStyle === 'function') {
          line = parseFloat(window.getComputedStyle(sections[0]).scrollMarginTop);
        }
        if (!line || isNaN(line)) {
          var nr = nav.getBoundingClientRect();
          line = (nr.bottom || nr.height || 56) + 8;
        }
        var current = 0;
        for (var i = 0; i < sections.length; i++) {
          if (sections[i].getBoundingClientRect().top - line <= 1) current = i;
          else break;
        }
        var btn = pillFor(current);
        if (btn && !btn.classList.contains('is-active')) {
          buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          centerInTrack(btn);
        }
      }
      function setupScrollSpy() {
        if (typeof window.IntersectionObserver !== 'function') return;
        var navH = nav.getBoundingClientRect().height || 56;
        var obs = new window.IntersectionObserver(function () {
          if (allMode) highlightCurrentSection();
        }, { rootMargin: '-' + Math.round(navH) + 'px 0px -60% 0px', threshold: 0 });
        sections.forEach(function (sec) { obs.observe(sec); });
      }

      var scrollSpyReady = false;
      function ensureScrollSpy() {
        if (scrollSpyReady) return;
        scrollSpyReady = true;
        setupScrollSpy();
      }

      buttons.forEach(function (btn) { btn.addEventListener('click', function () { activate(btn, true); }); });
      if (prev) prev.addEventListener('click', function () { scrollTrack(track.scrollLeft - Math.max(120, track.clientWidth * 0.6)); });
      if (next) next.addEventListener('click', function () { scrollTrack(track.scrollLeft + Math.max(120, track.clientWidth * 0.6)); });
      track.addEventListener('scroll', updateArrows);
      rocAddWinListener(rocInstanceId, 'resize', updateArrows);

      var spyScheduled = false;
      function onScrollSpy() {
        if (!allMode || spyScheduled) return;
        spyScheduled = true;
        var run = function () { spyScheduled = false; highlightCurrentSection(); };
        if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(run); else run();
      }
      rocAddWinListener(rocInstanceId, 'scroll', onScrollSpy, { passive: true });

      var initBtn = track.querySelector('.roc__catbtn.is-active') || buttons[0];
      if (initBtn) activate(initBtn, false, { center: false, measure: false });
      afterFirstPaint(function () {
        updateArrows();
      });
    }

    function buildCrossSell() {
      var prom = (settings.prominentCategories && settings.prominentCategories.length) ? settings.prominentCategories : null;
      if (!prom) return null;

      var idxByName = {};
      categoryNames.forEach(function (name, index) { idxByName[name] = String(index); });
      var btns = [];
      prom.forEach(function (name) {
        var idx = idxByName[String(name)];
        if (idx === undefined || idx === null) return;
        btns.push(el('button', { type: 'button', 'class': 'roc__catbtn roc__crosssell-btn', 'data-crosssell-target': String(idx) }, [catDisplay(String(name))]));
      });
      if (!btns.length) return null;
      return el('div', { 'class': 'roc__crosssell' }, [
        el('p', { 'class': 'roc__crosssell-title' }, [t(settings, 'crossSellTitle', 'Noch etwas dazu?')]),
        el('div', { 'class': 'roc__crosssell-btns' }, btns)
      ]);
    }

    function renderDeliveryFeedback() {
      var node = root.querySelector('[data-delivery-feedback]');
      if (!node) return;
      var fb = rocDeliveryFeedback(settings, state, cartSubtotal(state, itemsById));
      node.textContent = '';
      if (fb.mode === 'hidden') { node.hidden = true; return; }
      var kids = [];
      if (fb.mode === 'prompt') {
        kids.push(el('p', { 'class': 'roc__delivery-feedback-line roc__delivery-feedback-line--muted' }, [t(settings, 'deliveryCheckPrompt', 'PLZ eingeben, um Liefergebiet, Liefergebuehr und Mindestbestellwert zu pruefen.')]));
      } else if (fb.mode === 'unserved') {
        kids.push(el('p', { 'class': 'roc__delivery-feedback-line roc__delivery-feedback-line--warning' }, [t(settings, 'noDeliveryZone', 'Fuer diese PLZ liefern wir aktuell leider nicht.')]));
      } else {

        kids.push(el('p', { 'class': 'roc__delivery-feedback-line roc__delivery-feedback-line--ok' }, [t(settings, 'deliveryZoneAvailable', 'Liefergebiet verfuegbar.')]));
        if (fb.fee > 0) {
          kids.push(el('p', { 'class': 'roc__delivery-feedback-line' }, [t(settings, 'deliveryFeeInfo', 'Liefergebuehr: %1$s').replace('%1$s', money(fb.fee, settings.currency))]));
        }
        if (fb.min > 0) {
          kids.push(el('p', { 'class': 'roc__delivery-feedback-line' }, [minHint(settings, fb.min, fb.subtotal)]));
          if (fb.reached) {
            kids.push(el('p', { 'class': 'roc__delivery-feedback-line roc__delivery-feedback-line--ok' }, [t(settings, 'deliveryMinimumReached', 'Mindestbestellwert erreicht.')]));
          } else {
            kids.push(el('p', { 'class': 'roc__delivery-feedback-line roc__delivery-feedback-line--warning' }, [t(settings, 'deliveryMinimumMissing', 'Noch %1$s bis zum Mindestbestellwert.').replace('%1$s', money(fb.missing, settings.currency))]));
          }
        }

        if (settings.addressCheckMode === 'hard' && addrScope && addrScope.data && addrScope.count > 0
            && addrScope.zip === String(state.zip || '').trim()
            && rocCheckAddress(state, settings, addrScope) === '') {
          kids.push(el('p', { 'class': 'roc__delivery-feedback-line roc__delivery-feedback-line--ok' }, [t(settings, 'addressVerified', 'Adresse geprueft.')]));
        }
      }
      kids.forEach(function (k) { node.appendChild(k); });
      node.hidden = false;
    }

    function update() {

      var sMode = specialDayMode(settings, state.date);
      var pickupRadio = root.querySelector('input[name="type-' + root.id + '"][value="pickup"]');
      var deliveryRadio = root.querySelector('input[name="type-' + root.id + '"][value="delivery"]');
      var pickupBlocked = sMode === 'closed' || sMode === 'pickup_disabled';
      var deliveryBlocked = sMode === 'closed' || sMode === 'delivery_disabled';
      if (pickupRadio) pickupRadio.disabled = pickupBlocked;
      if (deliveryRadio) deliveryRadio.disabled = deliveryBlocked;
      var clearedType = false;
      if ((state.type === 'pickup' && pickupBlocked) || (state.type === 'delivery' && deliveryBlocked)) {
        state.type = '';
        if (pickupRadio) pickupRadio.checked = false;
        if (deliveryRadio) deliveryRadio.checked = false;
        if (state.time !== '') state.time = '';
        state.idempotencyKey = null;
        clearedType = true;
      }
      var specialNotice = root.querySelector('[data-special-notice]');
      if (specialNotice) {

        var noticeDate = String(state.date || '').trim() || todayStr;
        var noticeMode = specialDayMode(settings, noticeDate);
        var sMsg = '';
        if (noticeMode === 'closed') sMsg = t(settings, 'dateClosed', 'An diesem Tag nehmen wir keine Bestellungen an.');

        else if (noticeMode === 'delivery_disabled' && deliveryBookable) sMsg = t(settings, 'deliveryDayUnavailable', 'Lieferung ist an diesem Tag nicht verfuegbar.');
        else if (noticeMode === 'pickup_disabled' && pickupBookable) sMsg = t(settings, 'pickupDayUnavailable', 'Abholung ist an diesem Tag nicht verfuegbar.');
        var sNote = specialDayNote(settings, noticeDate);
        if (sMsg && sNote) sMsg = sMsg + ' (' + sNote + ')';
        specialNotice.textContent = sMsg;
        specialNotice.hidden = !sMsg;
      }
      if (clearedType) rebuildTimeSlots();

      var hasDateNow = !!String(state.date || '').trim();
      var asyncBlocked = !canOrder || (todayClosed && !hasDateNow);
      var waBtn = root.querySelector('button[data-channel="whatsapp"]');
      var mailBtn = root.querySelector('button[data-channel="mail"]');
      var phoneBtn = root.querySelector('button[data-channel="phone"]');
      if (waBtn) waBtn.disabled = asyncBlocked;
      if (mailBtn) mailBtn.disabled = asyncBlocked;
      if (phoneBtn) {
        var typeBlockedToday = (state.type === 'delivery' && !todayDeliveryAllowed) || (state.type === 'pickup' && !todayPickupAllowed);
        phoneBtn.disabled = !canOrder || !phoneTodayAllowed || typeBlockedToday;
      }

      var summary = root.querySelector('[data-summary]');
      var deliveryFields = root.querySelector('[data-delivery-fields]');
      var total = 0;
      var cartCount = 0;
      var rows = [];
      Object.keys(state.cart).forEach(function (id) {
        var qty = state.cart[id];
        var item = itemsById[id];
        if (!qty || !item) return;
        total += qty * Number(item.price || 0);
        cartCount += qty;
        rows.push(el('div', { 'class': 'roc__cartline' }, [
          el('span', { 'class': 'roc__cartline-label' }, [qty + 'x ' + item.name]),
          el('strong', { 'class': 'roc__cartline-price' }, [money(qty * item.price, settings.currency)]),
          el('span', { 'class': 'roc__cartline-controls' }, [
            el('button', { type: 'button', 'class': 'roc__cartbtn', 'data-cart-action': 'dec', 'data-cart-id': id, 'aria-label': t(settings, 'decOne', '1 weniger'), title: t(settings, 'decOne', '1 weniger') }, ['-']),
            el('button', { type: 'button', 'class': 'roc__cartbtn', 'data-cart-action': 'inc', 'data-cart-id': id, 'aria-label': t(settings, 'incOne', '1 mehr'), title: t(settings, 'incOne', '1 mehr') }, ['+']),
            el('button', { type: 'button', 'class': 'roc__cartbtn roc__cartbtn--remove', 'data-cart-action': 'remove', 'data-cart-id': id, 'aria-label': t(settings, 'removeItem', 'Entfernen'), title: t(settings, 'removeItem', 'Entfernen') }, ['\u00D7'])
          ])
        ]));
      });

      Object.keys(state.configuredCart).forEach(function (key) {
        var line = state.configuredCart[key];
        if (!line || !line.qty || !itemsById[line.id]) return;
        total += line.qty * Number(line.unitDisplayPrice || 0);
        cartCount += line.qty;
        var optLabels = configuredOptionLabels(line);
        var optText = optLabels.length ? optLabels.join(', ') : '';
        rows.push(el('div', { 'class': 'roc__cartline roc__cartline--configured' }, [
          el('span', { 'class': 'roc__cartline-label' }, [
            el('span', null, [line.qty + 'x ' + ((itemsById[line.id] && itemsById[line.id].name) || line.displayName)]),
            optText ? el('small', { 'class': 'roc__cartline-options' }, [optText]) : null
          ]),
          el('strong', { 'class': 'roc__cartline-price' }, [money(line.qty * Number(line.unitDisplayPrice || 0), settings.currency)]),
          el('span', { 'class': 'roc__cartline-controls' }, [
            el('button', { type: 'button', 'class': 'roc__cartbtn', 'data-config-action': 'dec', 'data-config-key': key, 'aria-label': t(settings, 'decOne', '1 weniger'), title: t(settings, 'decOne', '1 weniger') }, ['-']),
            el('button', { type: 'button', 'class': 'roc__cartbtn', 'data-config-action': 'inc', 'data-config-key': key, 'aria-label': t(settings, 'incOne', '1 mehr'), title: t(settings, 'incOne', '1 mehr') }, ['+']),
            el('button', { type: 'button', 'class': 'roc__cartbtn roc__cartbtn--remove', 'data-config-action': 'remove', 'data-config-key': key, 'aria-label': t(settings, 'removeItem', 'Entfernen'), title: t(settings, 'removeItem', 'Entfernen') }, ['\u00D7'])
          ])
        ]));
      });

      if (cartCount > 0) {
        var crossSell = buildCrossSell();
        if (crossSell) rows.push(crossSell);
      }
      var subtotal = total;
      var rates = deliveryRates(settings, state);
      if (state.type === 'delivery' && rates.fee > 0) {
        total += rates.fee;
        rows.push(el('div', null, [
          el('span', null, [t(settings, 'deliveryFee', 'Liefergebuehr')]),
          el('strong', null, [money(rates.fee, settings.currency)])
        ]));
      }
      if (!rows.length) rows.push(el('p', { 'class': 'roc__empty' }, [t(settings, 'cartEmpty', 'Warenkorb ist leer.')]));

      var displayTotal = total;
      var totalDiscounted = false;
      if (rocDiscountDisplayAllowed(data) && cartCount > 0) {
        var previewLines = [];
        Object.keys(state.cart).forEach(function (id) {
          var qty = state.cart[id];
          var it = itemsById[id];
          if (!qty || qty <= 0 || !it) return;
          var pc = (parseInt(it.priceCents, 10) || 0) || Math.round(Number(it.price || 0) * 100);
          previewLines.push({ id: parseInt(id, 10), qty: qty, unitPriceCents: pc, categoryIds: it.categoryIds || [] });
        });
        Object.keys(state.configuredCart).forEach(function (key) {
          var cl = state.configuredCart[key];
          if (!cl || !cl.qty || !itemsById[cl.id]) return;
          var upc = (parseInt(cl.unitDisplayPriceCents, 10) || 0) || Math.round(Number(cl.unitDisplayPrice || 0) * 100);
          previewLines.push({ id: parseInt(cl.id, 10), qty: cl.qty, unitPriceCents: upc, categoryIds: itemsById[cl.id].categoryIds || [] });
        });
        var deliveryCentsCtx = (state.type === 'delivery' && rates.fee > 0) ? Math.round(rates.fee * 100) : 0;
        var preview = rocDiscountPreview(previewLines, { type: state.type, deliveryCents: deliveryCentsCtx }, (data && data.discounts) || []);
        var discLabel = t(settings, 'discount', 'Rabatt');
        preview.goodsRows.forEach(function (dr) {
          var drLabel = discountLabel(dr, customerLocale);
          rows.push(el('div', { 'class': 'roc__discount-row' }, [
            el('span', null, [discLabel + (drLabel ? ' (' + drLabel + ')' : '')]),
            el('strong', null, ['-' + money(dr.amountCents / 100, settings.currency)])
          ]));
        });
        preview.deliveryRows.forEach(function (dr) {
          var drLabel = discountLabel(dr, customerLocale);
          rows.push(el('div', { 'class': 'roc__discount-row' }, [
            el('span', null, [t(settings, 'deliveryDiscount', 'Liefergebuehr-Rabatt') + (drLabel ? ' (' + drLabel + ')' : '')]),
            el('strong', null, ['-' + money(dr.amountCents / 100, settings.currency)])
          ]));
        });
        if ((preview.totalDiscountCents > 0 || preview.deliveryDiscountCents > 0)) {
          displayTotal = preview.finalTotalCents / 100;
          totalDiscounted = true;
        } else if (preview.missingCartDiscountCents > 0) {

          rows.push(el('p', { 'class': 'roc__discount-note' }, [
            t(settings, 'discountMissing', 'Noch %s bis zum Rabatt').replace('%s', money(preview.missingCartDiscountCents / 100, settings.currency))
          ]));
        }
      }
      rows.push(el('div', { 'class': totalDiscounted ? 'roc__total roc__total--discounted' : 'roc__total' }, [
        el('span', null, [t(settings, 'total', 'Total')]),
        el('strong', null, [money(displayTotal, settings.currency)])
      ]));
      if (state.type === 'delivery' && !rates.served) {

        rows.push(el('p', { 'class': 'roc__warning' }, [t(settings, 'noDeliveryZone', 'Fuer diese PLZ liefern wir aktuell leider nicht.')]));
      } else if (state.type === 'delivery' && rates.min > 0 && subtotal < rates.min) {
        rows.push(el('p', { 'class': 'roc__warning' }, [minHint(settings, rates.min, subtotal)]));
      }
      summary.textContent = '';
      rows.forEach(function (row) { summary.appendChild(row); });
      deliveryFields.hidden = state.type !== 'delivery';
      var timeLabel = root.querySelector('[data-time-label]');
      if (timeLabel) timeLabel.textContent = state.type === 'delivery' ? t(settings, 'deliveryTime', 'Lieferzeit') : t(settings, 'pickupTime', 'Abholzeit');
      Object.keys(itemsById).forEach(function (id) {
        var qty = root.querySelector('[data-qty="' + id + '"]');
        if (qty) qty.textContent = (state.cart[id] || 0) + configuredQtyFor(id);
      });

      var cartBarEl = root.querySelector('[data-cartbar]');
      if (cartBarEl && cartCount > 0) {
        var infoEl = cartBarEl.querySelector('[data-cartbar-info]');
        if (infoEl) {
          var itemsTxt = t(settings, 'cartBarItems', '%1$s Artikel').replace('%1$s', String(cartCount));
          var infoTextEl = infoEl.querySelector('[data-cartbar-text]');
          if (infoTextEl) { infoTextEl.textContent = itemsTxt + ' \u00B7 ' + money(subtotal, settings.currency); }
        }
      }
      lastCartbarCount = cartCount;
      wizMiniSubtotal = subtotal;
      syncCartbar();
      wizRender();
      renderDeliveryFeedback();
    }

    function ymOf(dateStr) { var p = String(dateStr).split('-'); return parseInt(p[0], 10) * 12 + (parseInt(p[1], 10) - 1); }
    function calClamp() {
      var cur = calView.y * 12 + calView.m;
      var lo = ymOf(todayStr);
      var hi = ymOf(maxDateStr);
      if (cur < lo) cur = lo;
      if (cur > hi) cur = hi;
      calView.y = Math.floor(cur / 12);
      calView.m = cur % 12;
    }
    function calPad(n) { return (n < 10 ? '0' : '') + n; }

    function calWeekdayLabels() {
      var out = [];
      for (var i = 0; i < 7; i++) {
        var d = new Date(Date.UTC(2024, 0, 1 + i));
        out.push(rocWeekdayFormatter(rocCalendarLocale(customerLocale)).format(d));
      }
      return out;
    }
    function selectCalendarDate(dateStr) {
      clearFieldErrors();
      state.date = dateStr;
      var dn = root.querySelector('[data-field="date"]');
      if (dn) dn.value = dateStr;
      var p = String(dateStr).split('-');
      calView.y = parseInt(p[0], 10);
      calView.m = parseInt(p[1], 10) - 1;
      rebuildTimeSlots();
      update();
      renderCalendar();
    }
    function renderCalendar() {
      var wrap = root.querySelector('[data-roc-calendar]');
      if (!wrap) return;
      calClamp();
      var y = calView.y, m = calView.m;
      var cur = y * 12 + m;
      var atMin = cur <= ymOf(todayStr);
      var atMax = cur >= ymOf(maxDateStr);
      var monthLabel = rocMonthFormatter(rocCalendarLocale(customerLocale)).format(new Date(Date.UTC(y, m, 1)));

      var header = el('div', { 'class': 'roc-calendar__header' }, [
        el('button', { type: 'button', 'class': 'roc-calendar__nav', 'data-cal-nav': 'prev', 'aria-label': t(settings, 'calendarPrevMonth', 'Vorheriger Monat'), disabled: atMin }, ['\u2039']),
        el('span', { 'class': 'roc-calendar__title' }, [monthLabel]),
        el('button', { type: 'button', 'class': 'roc-calendar__nav', 'data-cal-nav': 'next', 'aria-label': t(settings, 'calendarNextMonth', 'Naechster Monat'), disabled: atMax }, ['\u203A'])
      ]);

      var weekdayNodes = calWeekdayLabels().map(function (lbl) {
        return el('span', { 'class': 'roc-calendar__weekday' }, [lbl]);
      });
      var weekdays = el('div', { 'class': 'roc-calendar__weekdays' }, weekdayNodes);

      var firstWeekday = new Date(Date.UTC(y, m, 1)).getUTCDay();
      var leading = (firstWeekday + 6) % 7;
      var daysInMonth = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
      var cells = [];
      for (var b = 0; b < leading; b++) {
        cells.push(el('span', { 'class': 'roc-calendar__pad', 'aria-hidden': 'true' }));
      }
      for (var day = 1; day <= daysInMonth; day++) {
        var dateStr = y + '-' + calPad(m + 1) + '-' + calPad(day);
        var dstate = calendarDayState(settings, state.type, dateStr, todayStr, maxDateStr);
        var mode = specialDayMode(settings, dateStr);
        var cls = 'roc-calendar__day';
        if (dateStr === todayStr) cls += ' roc-calendar__day--today';
        if (dateStr === String(state.date || '')) cls += ' roc-calendar__day--selected';
        if (mode === 'closed') cls += ' roc-calendar__day--closed';
        else if (mode === 'delivery_disabled') cls += ' roc-calendar__day--delivery-disabled';
        else if (mode === 'pickup_disabled') cls += ' roc-calendar__day--pickup-disabled';
        if (!dstate.selectable) cls += ' roc-calendar__day--disabled';
        var props = { type: 'button', 'class': cls, 'data-cal-date': dateStr };
        if (!dstate.selectable) {

          props['aria-disabled'] = 'true';
          props.tabindex = '-1';
          props['data-cal-reason'] = dstate.reason;
        }
        cells.push(el('button', props, [String(day)]));
      }
      var grid = el('div', { 'class': 'roc-calendar__grid' }, cells);

      wrap.textContent = '';
      wrap.appendChild(header);
      wrap.appendChild(weekdays);
      wrap.appendChild(grid);
    }
    function buildCalendar() {
      var wrap = root.querySelector('[data-roc-calendar]');
      if (!wrap) return;

      wrap.addEventListener('click', function (event) {
        var nav = event.target.closest('[data-cal-nav]');
        if (nav) {
          if (nav.disabled) return;
          calView.m += (nav.getAttribute('data-cal-nav') === 'next') ? 1 : -1;
          if (calView.m < 0) { calView.m = 11; calView.y -= 1; }
          else if (calView.m > 11) { calView.m = 0; calView.y += 1; }
          renderCalendar();
          return;
        }
        var dayBtn = event.target.closest('[data-cal-date]');
        if (!dayBtn) return;
        if (dayBtn.getAttribute('aria-disabled') === 'true') {
          var reason = dayBtn.getAttribute('data-cal-reason');
          if (reason === 'dateClosed' || reason === 'deliveryDayUnavailable' || reason === 'pickupDayUnavailable') reportError(reason);
          return;
        }
        selectCalendarDate(dayBtn.getAttribute('data-cal-date'));
      });
      renderCalendar();
    }

    function commitNativeDate(value) {
      clearFieldErrors();
      state.date = value;
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        var dstate = calendarDayState(settings, state.type, value, todayStr, maxDateStr);
        if (!dstate.selectable) {
          state.date = '';
          if (state.time !== '') state.time = '';
          var dn = root.querySelector('[data-field="date"]');
          if (dn) dn.value = '';
          rebuildTimeSlots();
          update();
          renderCalendar();
          if (dstate.reason === 'dateClosed' || dstate.reason === 'deliveryDayUnavailable' || dstate.reason === 'pickupDayUnavailable') reportError(dstate.reason);
          return false;
        }
      }
      rebuildTimeSlots();
      update();
      renderCalendar();
      return true;
    }

    var fieldErrorTimer = null;

    function clearFieldErrors() {
      if (fieldErrorTimer) { window.clearTimeout(fieldErrorTimer); fieldErrorTimer = null; }
      Array.prototype.forEach.call(root.querySelectorAll('.roc__validation-highlight'), function (n) {
        n.classList.remove('roc__validation-highlight');
      });
      Array.prototype.forEach.call(root.querySelectorAll('[aria-invalid="true"]'), function (n) {
        n.removeAttribute('aria-invalid');
        n.removeAttribute('aria-describedby');
      });
      Array.prototype.forEach.call(root.querySelectorAll('.roc__fielderror'), function (n) { n.hidden = true; });
    }

    function firstEmptyField(names) {
      for (var i = 0; i < names.length; i++) {
        var node = root.querySelector('[data-field="' + names[i] + '"]');
        if (node && !String(node.value).trim()) return node;
      }
      return null;
    }

    function reportError(key, arg, customMessage) {
      clearFieldErrors();
      var groups = {
        requireType: 'type', deliveryNotBookable: 'type', pickupNotBookable: 'type', selectItem: 'cart', requireContact: 'contact', invalidPhone: 'contact',
        requireEmail: 'email', requireAddress: 'address', invalidZip: 'address', addressNotFound: 'address',
        addressNumberRequired: 'address', addressNumberUnknown: 'address', addressUnverifiable: 'address',
        noDeliveryZone: 'address', minNotReached: 'address', requireSlot: 'slot',
        slotPast: 'slot', slotLead: 'slot', slotUnavailable: 'slot',
        slotDeliveryUnavailable: 'slot', slotPickupUnavailable: 'slot',
        dateClosed: 'type', deliveryDayUnavailable: 'type', pickupDayUnavailable: 'type',
        requirePayment: 'payment',

        captchaFailed: 'captcha', modifierInvalid: 'cart'
      };
      var group = groups[key];
      var message = customMessage || errorMessage(key, arg);
      if (!group) { window.alert(message); return; }
      var focusEl = null;
      var highlightEl = null;
      if (group === 'type') {

        highlightEl = root.querySelector('[data-fieldgroup="type"]');
        focusEl = highlightEl;
      } else if (group === 'cart') {

        highlightEl = root.querySelector('.roc__category:not([hidden]) .roc__item') || root.querySelector('.roc__menu .roc__item') || root.querySelector('.roc__menu');
        focusEl = root.querySelector('.roc__category:not([hidden]) [data-action="inc"]') || root.querySelector('.roc__menu [data-action="inc"]') || highlightEl;
      } else if (key === 'requireContact') {
        focusEl = firstEmptyField(['firstName', 'lastName', 'phone']) || root.querySelector('[data-field="firstName"]');
        highlightEl = focusEl;
      } else if (key === 'requireAddress') {
        focusEl = firstEmptyField(['street', 'zip', 'city']) || root.querySelector('[data-field="street"]');
        highlightEl = focusEl;
      } else if (group === 'slot') {
        var dateEl = root.querySelector('[data-field="date"]');
        focusEl = (dateEl && !String(dateEl.value).trim()) ? dateEl : (root.querySelector('[data-field="time"]') || dateEl);
        highlightEl = focusEl;
      } else if (group === 'payment') {

        highlightEl = root.querySelector('[data-payment]');
        focusEl = highlightEl;
      } else if (group === 'captcha') {

        highlightEl = root.querySelector('[data-fieldgroup="captcha"]');
        focusEl = highlightEl;
      } else {

        var selMap = { invalidPhone: 'phone', requireEmail: 'email', invalidZip: 'zip', noDeliveryZone: 'zip', minNotReached: 'zip', addressUnverifiable: 'zip', addressNotFound: 'street', addressNumberRequired: 'street', addressNumberUnknown: 'street' };
        focusEl = root.querySelector('[data-field="' + selMap[key] + '"]');
        highlightEl = focusEl;
      }
      var msgEl = root.querySelector('[data-error="' + group + '"]');

      var addrHintEl = null;
      if ('addressNumberRequired' === key || 'addressNumberUnknown' === key) {
        var hintNode = root.querySelector('[data-addr-hint]');
        if (hintNode && !hintNode.hidden && String(hintNode.textContent || '').indexOf(message) !== -1) {
          if (!hintNode.id) hintNode.id = 'roc-addrhint-' + (root.id || 'roc');
          addrHintEl = hintNode;
          msgEl = null;
        }
      }

      if (!msgEl && !highlightEl && !focusEl && !addrHintEl) { window.alert(message); return; }
      if (msgEl) {
        msgEl.textContent = message;
        msgEl.hidden = false;
        msgEl.setAttribute('role', 'alert');
        if (!msgEl.id) msgEl.id = 'roc-err-' + (root.id || 'roc') + '-' + group;
      }

      if ('cart' === group && msgEl && highlightEl && highlightEl.classList.contains('roc__item')) {
        highlightEl.appendChild(msgEl);
      }
      if (highlightEl) highlightEl.classList.add('roc__validation-highlight');

      var scrollEl = focusEl || highlightEl;
      if (scrollEl) {
        try { scrollEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { try { scrollEl.scrollIntoView(); } catch (e2) {} }
      }
      if (focusEl) {
        if (msgEl && msgEl.id) { focusEl.setAttribute('aria-invalid', 'true'); focusEl.setAttribute('aria-describedby', msgEl.id); }
        else if (addrHintEl) { focusEl.setAttribute('aria-invalid', 'true'); focusEl.setAttribute('aria-describedby', addrHintEl.id); }
        try { focusEl.focus({ preventScroll: true }); } catch (e3) { try { focusEl.focus(); } catch (e4) {} }
      }
      fieldErrorTimer = window.setTimeout(clearFieldErrors, 8000);
    }

    function syncCustomerFieldsFromDom() {
      ['firstName', 'lastName', 'phone', 'email', 'street', 'zip', 'city', 'comment', 'date', 'time'].forEach(function (field) {
        var node = root.querySelector('[data-field="' + field + '"]');
        if (node) state[field] = node.value || '';
      });

      var pmNode = root.querySelector('[data-field="paymentMethod"]:checked');
      if (pmNode) state.paymentMethod = pmNode.value || '';
    }

    function placeOrder(button, channel) {
      syncCustomerFieldsFromDom();
      if (!canOrder || state.submitting) return;
      channel = channel || (hasServer ? 'web' : 'whatsapp');

      var hasItems = cartHasItems();
      if (!hasItems && channel !== 'phone') { reportError('selectItem'); return; }

      if (state.type !== 'pickup' && state.type !== 'delivery') { reportError('requireType'); return; }

      rebuildTimeSlots();
      var missing = validationError(state, settings, channel, addrScope);
      if (missing) { reportError(missing); return; }

      if (state.type === 'delivery' && channel !== 'phone') {
        var rates = deliveryRates(settings, state);
        if (!rates.served) { reportError('noDeliveryZone'); return; }
        var sub = cartSubtotal(state, itemsById);
        if (rates.min > 0 && sub < rates.min) { reportError('minNotReached', null, minHint(settings, rates.min, sub)); return; }
      }
      var built = buildMessage(state, settings, itemsById);

      if (!order || !order.endpoint) {

        window.open('https://wa.me/' + settings.whatsappNumber + '?text=' + encodeURIComponent(built.text), '_blank', 'noopener');
        return;
      }

      submitToServer(button, channel);
    }

    function submitToServer(button, channel) {
      var captchaToken = captchaProvider ? readCaptchaToken(root) : '';
      if (captchaProvider && !captchaToken) {

        reportError('captchaFailed');
        return;
      }
      state.submitting = true;
      if (button) button.disabled = true;
      if (!state.idempotencyKey) state.idempotencyKey = uuid();

      var lines = [];
      Object.keys(state.cart).forEach(function (id) {
        if (state.cart[id] > 0) lines.push({ id: parseInt(id, 10), qty: state.cart[id] });
      });

      Object.keys(state.configuredCart).forEach(function (key) {
        var line = state.configuredCart[key];
        if (line && line.qty > 0) {
          lines.push({ id: parseInt(line.id, 10), qty: line.qty, modifiers: line.modifiers });
        }
      });

      var payload = {
        type: state.type,
        channel: channel,
        payment_method: state.paymentMethod || '',
        lines: lines,
        customer: { first_name: state.firstName, last_name: state.lastName, phone: state.phone, email: state.email, street: state.street, zip: state.zip, city: state.city },
        comment: state.comment,
        requested_date: state.date,
        requested_time: state.time,
        idempotency_key: state.idempotencyKey,
        website: state.website || '',
        customer_locale: state.customerLocale || '',
        captcha_token: captchaToken
      };

      var noncePromise = (order.nonceEndpoint)
        ? fetch(order.nonceEndpoint, { method: 'GET', credentials: 'same-origin', cache: 'no-store' })
            .then(function (res) { return res.json(); })
            .then(function (json) { return (json && json.nonce) ? json.nonce : (order.nonce || ''); })
            .catch(function () { return order.nonce || ''; })
        : Promise.resolve(order.nonce || '');

      noncePromise.then(function (nonce) {
        return fetch(order.endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-ROC-Nonce': nonce },
          body: JSON.stringify(payload)
        });
      }).then(function (res) {
        return res.json().then(function (json) { return json; }, function () { return { ok: false, errors: ['serverError'] }; });
      }).then(function (json) {
        state.submitting = false;
        if (button) button.disabled = false;
        if (json && json.ok) {
          resetCaptcha(captchaProvider, captchaBox);

          if (json.live_pending && json.live_token && json.live_status_endpoint) {

            state.submitting = true;
            showLiveWaitingModal(String(json.live_token), String(json.live_status_endpoint), json.order_number);
            return;
          }

          state.idempotencyKey = null;

          if (channel === 'phone' && telUrl) {
            window.location.href = telUrl;
          }

          confirmOrder(json.order_number, channel === 'whatsapp' ? (json.whatsapp_url || '') : '');
          state.cart = {};
          state.configuredCart = {};
          resetForm();
          update();
          persistCart();
        } else if (json && json.code === 'itemsRemoved') {

          resetCaptcha(captchaProvider, captchaBox);
          var removed = (json.removed && json.removed.length) ? json.removed : [];
          removed.forEach(function (item) {
            var removedId = String(item && item.id != null ? item.id : '');
            if (removedId === '') return;
            delete state.cart[removedId];

            Object.keys(state.configuredCart || {}).forEach(function (key) {
              var line = state.configuredCart[key];
              if (line && String(line.id) === removedId) delete state.configuredCart[key];
            });
          });
          state.idempotencyKey = null;
          update();
          persistCart();
          var names = removed.map(function (item) {
            return (item && item.name) ? item.name : ('#' + (item && item.id != null ? item.id : '?'));
          }).join(', ');
          window.alert(errorMessage('itemsRemoved', names));
        } else {
          resetCaptcha(captchaProvider, captchaBox);
          var key = (json && json.errors && json.errors[0]) || 'serverError';

          if (typeof wizGoto === 'function') {
            var wizTarget = rocStepForError(key);
            if (wizTarget) wizGoto(wizTarget);
          }
          reportError(key);
        }
      }).catch(function () {
        state.submitting = false;
        if (button) button.disabled = false;
        window.alert(errorMessage('serverError'));
      });
    }

    function errorMessage(key, arg) {
      var fallbacks = {
        requireContact: 'Bitte Name und Telefonnummer angeben.',
        requirePayment: 'Bitte Zahlungsart waehlen.',
        requireType: 'Bitte Abholung oder Lieferung waehlen.',
        requireEmail: 'Bitte eine gueltige E-Mail-Adresse angeben.',
        channelUnavailable: 'Dieser Bestellkanal ist aktuell nicht verfuegbar.',
        deliveryNotBookable: 'Lieferung derzeit nicht verfuegbar.',
        pickupNotBookable: 'Abholung derzeit nicht verfuegbar.',
        requireAddress: 'Bitte vollstaendige Lieferadresse angeben.',
        invalidPhone: 'Bitte eine gueltige Schweizer Telefonnummer angeben.',
        invalidZip: 'Bitte eine gueltige Schweizer PLZ angeben (vier Ziffern).',
        addressNotFound: 'Diese Adresse konnten wir nicht finden. Bitte pruefen Sie Ihre Eingabe.',
        addressNumberUnknown: 'Diese Hausnummer kennen wir an dieser Strasse nicht. Bitte pruefen Sie die Hausnummer.',
        addressUnverifiable: 'Diese Lieferadresse kann zurzeit nicht geprueft werden. Bitte bestellen Sie telefonisch.',
        minNotReached: 'Mindestbestellwert fuer Lieferung nicht erreicht.',
        selectItem: 'Bitte zuerst mindestens einen Artikel waehlen.',
        requireSlot: 'Bitte Datum und Uhrzeit waehlen.',
        slotPast: 'Der gewaehlte Zeitpunkt liegt in der Vergangenheit.',
        slotLead: 'Bitte mindestens %1$s Minuten im Voraus bestellen.',
        slotUnavailable: 'Fuer diesen Zeitpunkt nehmen wir keine Bestellungen an.',
        slotDeliveryUnavailable: 'Lieferung ist zu diesem Zeitpunkt nicht verfuegbar.',
        slotPickupUnavailable: 'Abholung ist zu diesem Zeitpunkt nicht verfuegbar.',
        dateClosed: 'An diesem Tag nehmen wir keine Bestellungen an.',
        deliveryDayUnavailable: 'Lieferung ist an diesem Tag nicht verfuegbar.',
        pickupDayUnavailable: 'Abholung ist an diesem Tag nicht verfuegbar.',
        noDeliveryZone: 'Fuer diese PLZ liefern wir aktuell leider nicht.',
        noOrderType: 'Aktuell ist weder Abholung noch Lieferung aktiviert.',
        unknownItem: 'Ein Artikel ist nicht mehr verfuegbar. Bitte Auswahl pruefen.',
        modifierInvalid: 'Bitte pruefen Sie die Zusatzoptionen.',
        itemsRemoved: 'Folgende Artikel sind nicht mehr verfuegbar und wurden aus dem Warenkorb entfernt: %1$s. Bitte pruefen Sie die Bestellung und bestaetigen Sie sie erneut.',
        closed: 'Wir nehmen aktuell keine Online-Bestellungen entgegen.',
        rateLimited: 'Zu viele Bestellungen in kurzer Zeit. Bitte spaeter erneut versuchen.',
        serverError: 'Bestellung konnte nicht gesendet werden. Bitte erneut versuchen.',
        captchaFailed: 'Bitte bestaetigen Sie, dass Sie kein Roboter sind, und versuchen Sie es erneut.'
      };
      if (key === 'slotLead') {
        return t(settings, 'slotLead', fallbacks.slotLead).replace('%1$s', String(Number(settings.leadMinutes || 0)));
      }
      if (key === 'itemsRemoved') {
        return t(settings, 'itemsRemoved', fallbacks.itemsRemoved).replace('%1$s', String(arg == null ? '' : arg));
      }
      if (key === 'addressNumberRequired') {

        return t(settings, 'addressNumberMissing', 'Bitte geben Sie die Hausnummer an.');
      }
      return t(settings, key, fallbacks[key] || fallbacks.serverError);
    }

    function confirmOrder(number, whatsappUrl) {
      var modal = root.querySelector('[data-confirm-modal]');
      if (!modal) return;
      var title = modal.querySelector('[data-confirm-number]');
      var textEl = modal.querySelector('[data-confirm-text]');
      var appetitEl = modal.querySelector('[data-confirm-appetit]');
      var waLink = modal.querySelector('[data-confirm-wa]');
      var isWhatsapp = !!whatsappUrl;

      if (title) {
        title.textContent = (isWhatsapp
          ? t(settings, 'whatsappPreparedTitle', 'Bestellung vorbereitet')
          : t(settings, 'orderPlaced', 'Bestellung erfasst')) + (number ? ': ' + number : '');
      }
      if (textEl) {
        textEl.textContent = isWhatsapp
          ? t(settings, 'whatsappHandoffText', 'Ihre Bestellung ist bei uns erfasst. Bitte oeffnen Sie jetzt WhatsApp und senden Sie die vorbereitete Nachricht ab.')
          : t(settings, 'orderThanks', 'Danke fuer Ihre Bestellung. Wir verarbeiten Ihren Auftrag so schnell wie moeglich und melden uns bei Bedarf bei Ihnen.');
      }

      if (appetitEl) appetitEl.hidden = isWhatsapp;
      if (waLink) {
        if (isWhatsapp) {
          waLink.href = whatsappUrl;
          waLink.textContent = t(settings, 'whatsappOpenSend', 'WhatsApp oeffnen und Nachricht senden');
          waLink.hidden = false;
        } else {
          waLink.removeAttribute('href');
          waLink.textContent = t(settings, 'sendWhatsapp', 'Jetzt per WhatsApp senden');
          waLink.hidden = true;
        }
      }
      modal.hidden = false;
      root.classList.add('roc--modal-open');
    }

    function closeConfirm() {
      var modal = root.querySelector('[data-confirm-modal]');
      if (modal) modal.hidden = true;
      root.classList.remove('roc--modal-open');
    }

    var liveTimers = { poll: null, tick: null };
    var liveRemaining = 0;
    var liveFinished = false;

    function clearLiveTimers() {
      if (liveTimers.poll) { window.clearInterval(liveTimers.poll); liveTimers.poll = null; }
      if (liveTimers.tick) { window.clearInterval(liveTimers.tick); liveTimers.tick = null; }
    }

    function closeLive() {

      if (!liveFinished) return;
      clearLiveTimers();
      var modal = root.querySelector('[data-live-modal]');
      if (modal) modal.hidden = true;
      root.classList.remove('roc--modal-open');

      state.submitting = false;
      state.idempotencyKey = null;
      clearLive();
    }

    function showLiveWaitingModal(token, endpoint, orderNumber, seedRemaining) {
      var modal = root.querySelector('[data-live-modal]');
      if (!modal) return;
      var titleEl = modal.querySelector('[data-live-title]');
      var textEl = modal.querySelector('[data-live-text]');
      var cdEl = modal.querySelector('[data-live-countdown]');
      var callEl = modal.querySelector('[data-live-call]');
      var closeBtn = modal.querySelector('[data-live-close]');
      clearLiveTimers();
      liveFinished = false;

      liveRemaining = ( typeof seedRemaining === 'number' && seedRemaining >= 0 ) ? seedRemaining : 240;

      persistLive(token, endpoint, orderNumber);

      function fmt(s) { s = Math.max(0, s | 0); var m = Math.floor(s / 60); var ss = s % 60; return m + ':' + (ss < 10 ? '0' : '') + ss; }
      function renderCountdown() { if (cdEl) cdEl.textContent = t(settings, 'liveCountdownLabel', 'Verbleibende Zeit') + ' ' + fmt(liveRemaining); }
      function finish(stateName) {
        if (liveFinished) return;
        liveFinished = true;
        clearLive();
        clearLiveTimers();
        if (cdEl) cdEl.hidden = true;
        if (closeBtn) closeBtn.hidden = false;
        if (stateName === 'accepted') {
          if (titleEl) titleEl.textContent = t(settings, 'liveAcceptedTitle', 'Bestellung angenommen') + (orderNumber ? ': ' + orderNumber : '');
          if (textEl) textEl.textContent = t(settings, 'liveAcceptedText', 'Ihre Bestellung wurde angenommen. Eine Bestaetigung folgt per E-Mail.');

          state.cart = {};
          state.configuredCart = {};
          resetForm();
          update();
          persistCart();
        } else if (stateName === 'rejected') {
          if (titleEl) titleEl.textContent = t(settings, 'liveRejectedTitle', 'Bestellung abgelehnt');
          if (textEl) textEl.textContent = t(settings, 'liveRejectedText', 'Der Betrieb konnte Ihre Bestellung leider nicht annehmen.');

        } else {

          if (titleEl) titleEl.textContent = t(settings, 'liveTimeoutTitle', 'Bestellung uebermittelt');
          var phone = settings.restaurantPhone ? String(settings.restaurantPhone) : '';
          if (phone) {
            if (textEl) textEl.textContent = t(settings, 'liveTimeoutText', 'Ihre Bestellung wurde uebermittelt, aber noch nicht bestaetigt. Bitte kontaktieren Sie uns telefonisch.');
            if (callEl) {
              callEl.setAttribute('href', 'tel:' + phone.replace(/[^\d+]/g, ''));
              callEl.hidden = false;
            }
          } else if (textEl) {
            textEl.textContent = t(settings, 'liveTimeoutTextNoPhone', 'Ihre Bestellung wurde uebermittelt, aber noch nicht bestaetigt. Bitte warten Sie auf die Bestaetigung per E-Mail.');
          }
        }
      }
      function poll() {
        var url = endpoint + (endpoint.indexOf('?') >= 0 ? '&' : '?') + 'token=' + encodeURIComponent(token);
        fetch(url, { method: 'GET', cache: 'no-store' })
          .then(function (res) {
            var status = res.status;
            return res.json().then(function (j) { return { status: status, body: j }; }, function () { return { status: status, body: null }; });
          })
          .then(function (r) {
            if (liveFinished) return;

            if (r.status === 429) return;
            var j = r.body;
            if (!j) return;
            var st = j.state;
            if (st === 'accepted' || st === 'rejected' || st === 'timeout' || st === 'invalid') { finish(st); return; }

            if (typeof j.remaining_seconds === 'number' && j.remaining_seconds >= 0) liveRemaining = j.remaining_seconds;
            if (liveRemaining <= 0) { finish('timeout'); return; }
            renderCountdown();
          })
          .catch(function () {  });
      }
      function tick() {
        if (liveFinished) return;
        liveRemaining = Math.max(0, liveRemaining - 1);
        renderCountdown();
        if (liveRemaining <= 0) {
          if (liveTimers.tick) { window.clearInterval(liveTimers.tick); liveTimers.tick = null; }
          poll();
        }
      }

      if (titleEl) titleEl.textContent = t(settings, 'liveWaitingTitle', 'Bestellung wird geprueft') + (orderNumber ? ': ' + orderNumber : '');
      if (textEl) textEl.textContent = t(settings, 'liveWaitingText', 'Der Betrieb bestaetigt Ihre Bestellung gleich. Bitte einen Moment warten.');
      if (cdEl) cdEl.hidden = false;
      if (closeBtn) closeBtn.hidden = true;
      renderCountdown();
      modal.hidden = false;
      root.classList.add('roc--modal-open');
      poll();
      liveTimers.poll = window.setInterval(poll, 5000);
      liveTimers.tick = window.setInterval(tick, 1000);
    }

    function resetForm() {

      ['firstName', 'lastName', 'phone', 'email', 'street', 'zip', 'city', 'comment', 'date', 'time', 'website'].forEach(function (field) {
        state[field] = '';
        var node = root.querySelector('[data-field="' + field + '"]');
        if (node) node.value = '';
      });
      var emailErr = root.querySelector('[data-error="email"]');
      if (emailErr) emailErr.hidden = true;

      addrScope = { zip: '', data: null, count: 0 };
      rocAddrClearHint();

      state.type = '';
      var pickupRadio = root.querySelector('input[name="type-' + root.id + '"][value="pickup"]');
      var deliveryRadio = root.querySelector('input[name="type-' + root.id + '"][value="delivery"]');
      if (pickupRadio) pickupRadio.checked = false;
      if (deliveryRadio) deliveryRadio.checked = false;
      state.paymentMethod = '';
      var pmChecked = root.querySelector('[data-field="paymentMethod"]:checked');
      if (pmChecked) pmChecked.checked = false;
      wizCurrent = 'service';
      wizRender();

      rebuildTimeSlots();
      renderCalendar();
    }

    var toastTimer = null;
    function showAddedToast() {
      var toastEl = root.querySelector('[data-toast]');
      if (!toastEl) return;
      toastEl.classList.add('is-visible');
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toastEl.classList.remove('is-visible'); }, 1600);
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        var lgm = root.querySelector('[data-legend-modal]');
        if (lgm && !lgm.hidden) { closeLegendModal(); return; }
        var sm = root.querySelector('[data-status-modal]');
        if (sm && !sm.hidden) { closeStatusModal(); return; }
      }
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') { return; }
      var trigger = event.target && event.target.closest ? event.target.closest('[data-product-open]') : null;
      if (!trigger) { return; }
      event.preventDefault();
      var kItem = itemsById[trigger.getAttribute('data-product-open')];
      if (kItem) { openConfigurator(kItem); }
    });
    root.addEventListener('click', function (event) {

      var crossSellBtn = event.target.closest('[data-crosssell-target]');
      if (crossSellBtn) {
        var csTarget = crossSellBtn.getAttribute('data-crosssell-target');
        var pill = root.querySelector('.roc__catnav-track .roc__catbtn[data-cat-target="' + csTarget + '"]');
        if (pill) pill.click();
        return;
      }

      if (event.target.closest('[data-cartbar-jump]')) {
        var cartPanel = root.querySelector('.roc__cart');
        if (cartPanel) { try { cartPanel.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { try { cartPanel.scrollIntoView(); } catch (e2) {} } }
        return;
      }
      var modalEl = root.querySelector('[data-confirm-modal]');
      if (event.target.closest('[data-confirm-close]') || (modalEl && !modalEl.hidden && event.target === modalEl)) {
        closeConfirm();
        return;
      }

      var waHandoff = event.target.closest('[data-confirm-wa]');
      if (waHandoff && waHandoff.getAttribute('href')) {
        var confirmTextEl = modalEl ? modalEl.querySelector('[data-confirm-text]') : null;
        if (confirmTextEl) confirmTextEl.textContent = t(settings, 'whatsappOpenedText', 'WhatsApp wurde geoeffnet. Bitte senden Sie dort die vorbereitete Nachricht ab.');
        waHandoff.textContent = t(settings, 'whatsappOpenAgain', 'WhatsApp nochmals oeffnen');

      }
      var liveModalEl = root.querySelector('[data-live-modal]');
      if (event.target.closest('[data-live-close]') || (liveModalEl && !liveModalEl.hidden && event.target === liveModalEl)) {
        closeLive();
        return;
      }
      var cfgModalEl = root.querySelector('[data-config-modal]');
      if (event.target.closest('[data-config-close]') || (cfgModalEl && !cfgModalEl.hidden && event.target === cfgModalEl)) {
        closeConfigurator();
        return;
      }
      var statusModalEl = root.querySelector('[data-status-modal]');
      if (event.target.closest('[data-status-close]') || (statusModalEl && !statusModalEl.hidden && event.target === statusModalEl)) {
        closeStatusModal();
        return;
      }

      if (event.target.closest('[data-legend-open]')) {
        openLegendModal();
        return;
      }
      var legendModalEl = root.querySelector('[data-legend-modal]');
      if (event.target.closest('[data-legend-close]') || (legendModalEl && !legendModalEl.hidden && event.target === legendModalEl)) {
        closeLegendModal();
        return;
      }

      var openTrigger = event.target.closest('[data-product-open]');
      if (openTrigger) {
        var openId = openTrigger.getAttribute('data-product-open');
        var openItem = itemsById[openId];
        if (openItem) { openConfigurator(openItem); }
        return;
      }
      var actionButton = event.target.closest('button[data-action]');
      if (actionButton) {
        var article = event.target.closest('.roc__item');
        var id = article && article.getAttribute('data-id');
        if (!id) return;
        var cfgItem = itemsById[id];
        if (hasModifierGroups(cfgItem)) {

          if (actionButton.getAttribute('data-action') === 'inc') {
            openConfigurator(cfgItem);
          } else if (actionButton.getAttribute('data-action') === 'dec') {
            var cfgKeys = Object.keys(state.configuredCart);
            var lastCfgKey = null;
            for (var ci = cfgKeys.length - 1; ci >= 0; ci--) {
              var cfgLine = state.configuredCart[cfgKeys[ci]];
              if (cfgLine && String(cfgLine.id) === String(id) && cfgLine.qty > 0) { lastCfgKey = cfgKeys[ci]; break; }
            }
            if (lastCfgKey) {
              state.configuredCart[lastCfgKey].qty = Math.max(0, state.configuredCart[lastCfgKey].qty - 1);
              if (state.configuredCart[lastCfgKey].qty === 0) delete state.configuredCart[lastCfgKey];
              state.idempotencyKey = null;
              update();
              persistCart();
            }
          }
          return;
        }
        state.cart[id] = state.cart[id] || 0;
        var prevQty = state.cart[id];
        if (actionButton.getAttribute('data-action') === 'inc') state.cart[id] = Math.min(limit, state.cart[id] + 1);
        if (actionButton.getAttribute('data-action') === 'dec') state.cart[id] = Math.max(0, state.cart[id] - 1);
        if (actionButton.getAttribute('data-action') === 'inc' && state.cart[id] > prevQty) showAddedToast();
        state.idempotencyKey = null;
        update();
        persistCart();
      }

      var cartButton = event.target.closest('button[data-cart-action]');
      if (cartButton) {
        var cartId = cartButton.getAttribute('data-cart-id');
        if (!cartId) return;
        var cartAction = cartButton.getAttribute('data-cart-action');
        if (cartAction === 'remove') {
          delete state.cart[cartId];
        } else {
          state.cart[cartId] = state.cart[cartId] || 0;
          if (cartAction === 'inc') state.cart[cartId] = Math.min(limit, state.cart[cartId] + 1);
          if (cartAction === 'dec') {
            state.cart[cartId] = Math.max(0, state.cart[cartId] - 1);
            if (state.cart[cartId] === 0) delete state.cart[cartId];
          }
        }
        state.idempotencyKey = null;
        update();
        persistCart();
        return;
      }

      var configButton = event.target.closest('button[data-config-action]');
      if (configButton) {
        var ckey = configButton.getAttribute('data-config-key');
        if (!ckey || !state.configuredCart[ckey]) return;
        var cAction = configButton.getAttribute('data-config-action');
        if (cAction === 'remove') {
          delete state.configuredCart[ckey];
        } else if (cAction === 'inc') {
          state.configuredCart[ckey].qty = Math.min(limit, state.configuredCart[ckey].qty + 1);
        } else if (cAction === 'dec') {
          state.configuredCart[ckey].qty = Math.max(0, state.configuredCart[ckey].qty - 1);
          if (state.configuredCart[ckey].qty === 0) delete state.configuredCart[ckey];
        }
        state.idempotencyKey = null;
        update();
        persistCart();
        return;
      }
      var channelButton = event.target.closest('button[data-channel]');
      if (channelButton) {
        placeOrder(channelButton, channelButton.getAttribute('data-channel'));
      }
    });

    function refreshSlotsOnOpen(event) {
      var target = event.target;
      if (target && target.getAttribute && target.getAttribute('data-field') === 'time') rebuildTimeSlots();
    }
    root.addEventListener('focusin', refreshSlotsOnOpen);
    root.addEventListener('mousedown', refreshSlotsOnOpen);

    root.addEventListener('change', function (event) {
      var isDateField = event.target.getAttribute && event.target.getAttribute('data-field') === 'date';

      if (!isDateField) clearFieldErrors();
      if (event.target.name === 'type-' + root.id) {
        var previousType = state.type;
        state.type = event.target.value;

        if (previousType !== state.type) {
          state.time = '';
          var timeField = root.querySelector('[data-field="time"]');
          if (timeField) timeField.value = '';
        }
        update();
        persistCart();

        rebuildTimeSlots();
        renderCalendar();
        rocAddrMaybeLoad();
        rocAddrRenderHint(false);
      }
      var changedField = event.target.getAttribute('data-field');
      if (changedField === 'zip') rocAddrMaybeLoad();
      if (changedField === 'street') rocAddrRenderHint(true);

      if (changedField === 'time') {
        state.time = event.target.value;
        update();
      }

      if (changedField === 'date') {
        commitNativeDate(event.target.value);
      }
    });
    root.addEventListener('input', function (event) {
      var field = event.target.getAttribute('data-field');
      if (!field) return;
      if (field === 'date') { commitNativeDate(event.target.value); return; }
      clearFieldErrors();
      state[field] = event.target.value;
      if (field === 'time' || field === 'zip') update();
      if (field === 'zip') rocAddrMaybeLoad();
      if (field === 'street') rocAddrRenderHint(false);
    });
    update();

    var addrScope = { zip: '', data: null, count: 0 };

    function rocAddrClearHint() {
      var hintEl = root.querySelector('[data-addr-hint]');
      if (!hintEl) return;
      while (hintEl.firstChild) hintEl.removeChild(hintEl.firstChild);
      hintEl.className = 'roc__addr-hint';
      hintEl.hidden = true;
    }

    function rocAddrMode() {
      var mode = settings && settings.addressCheckMode;
      return (mode === 'off' || mode === 'soft' || mode === 'hard') ? mode : 'soft';
    }

    function rocAddrFlag(on, doScroll) {
      var input = root.querySelector('[data-field="street"]');
      if (input) {
        if (on) { input.classList.add('roc__addr-attention'); }
        else { input.classList.remove('roc__addr-attention'); }
      }
      if (on && doScroll) {
        var target = root.querySelector('[data-addr-hint]') || input;
        if (target && target.scrollIntoView) {
          try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          catch (e) { target.scrollIntoView(); }
        }
      }
    }

    function rocAddrRenderHint(doScroll) {
      var hintEl = root.querySelector('[data-addr-hint]');
      if (!hintEl) return;
      rocAddrClearHint();
      rocAddrFlag(false);
      if (state.type !== 'delivery') return;
      var street = String(state.street || '').replace(/^\s+|\s+$/g, '');
      if (!street) return;

      if (rocAddrMode() !== 'off' && addrScope.data && addrScope.count > 0) {
        var result = rocAddrMatch(state.street, addrScope.data.streets || []);
        if (result.status === 'suggest' && result.suggestion) {
          var msg = String(t(settings, 'addressSuggest', 'Meinten Sie %s?')).replace('%s', result.suggestion);
          hintEl.appendChild(el('span', { 'class': 'roc__addr-hint-text' }, [msg + ' ']));
          var applyBtn = el('button', { type: 'button', 'class': 'roc__addr-hint-apply' }, [t(settings, 'addressApply', 'Übernehmen')]);
          applyBtn.addEventListener('click', function () {
            var parsed = rocAddrParseHouseNumber(state.street);
            var next = result.suggestion + (parsed.number ? ' ' + parsed.number : '');
            var input = root.querySelector('[data-field="street"]');
            if (input) { input.value = next; input.focus(); }
            state.street = next;
            rocAddrRenderHint(false);
          });
          hintEl.appendChild(applyBtn);
          hintEl.className = 'roc__addr-hint is-suggest';
          hintEl.hidden = false;
          rocAddrFlag(true, doScroll);
          return;
        }
        if (result.status === 'notfound') {
          hintEl.appendChild(el('span', { 'class': 'roc__addr-hint-text' }, [t(settings, 'addressNotFound', 'Diese Adresse konnten wir nicht finden. Bitte pruefen Sie Ihre Eingabe.')]));
          hintEl.className = 'roc__addr-hint is-notfound';
          hintEl.hidden = false;
          rocAddrFlag(true, doScroll);
          return;
        }

        if (result.status === 'numberUnknown') {
          hintEl.appendChild(el('span', { 'class': 'roc__addr-hint-text' }, [t(settings, 'addressNumberUnknown', 'Diese Hausnummer kennen wir an dieser Strasse nicht. Bitte pruefen Sie die Hausnummer.')]));
          hintEl.className = 'roc__addr-hint ' + (rocAddrMode() === 'hard' ? 'is-blocking' : 'is-notfound');
          hintEl.hidden = false;
          rocAddrFlag(true, doScroll);
          return;
        }
      }

      if (rocAddrParseHouseNumber(state.street).number === '') {
        var hardNumber = rocAddrMode() === 'hard';
        hintEl.appendChild(el('span', { 'class': 'roc__addr-hint-text' }, [t(settings, 'addressNumberMissing', 'Bitte geben Sie die Hausnummer an.')]));
        hintEl.className = 'roc__addr-hint ' + (hardNumber ? 'is-blocking' : 'is-missingnumber');
        hintEl.hidden = false;
        if (hardNumber) rocAddrFlag(true, doScroll);
      }
    }

    function rocAddrApplyCityAutofill() {
      var json = addrScope.data;
      if (!json || !json.cities || json.cities.length !== 1) return;
      if (String(state.city || '').replace(/^\s+|\s+$/g, '') !== '') return;
      var cityInput = root.querySelector('[data-field="city"]');
      if (cityInput) cityInput.value = json.cities[0];
      state.city = json.cities[0];
    }

    function rocAddrMaybeLoad() {
      if (rocAddrMode() === 'off' || !order || !order.addressEndpoint) { rocAddrClearHint(); return; }
      var zip = normalizePostcode(state.zip);
      if (!/^[1-9]\d{3}$/.test(zip)) { rocAddrClearHint(); return; }
      if (addrScope.zip === zip && addrScope.data) { rocAddrApplyCityAutofill(); rocAddrRenderHint(false); return; }
      var url = order.addressEndpoint + (order.addressEndpoint.indexOf('?') >= 0 ? '&' : '?') + 'zip=' + encodeURIComponent(zip);
      fetch(url, { method: 'GET', credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) {
          if (!json || normalizePostcode(state.zip) !== zip) return;
          addrScope = { zip: zip, data: json, count: (typeof json.count === 'number' ? json.count : 0) };
          rocAddrApplyCityAutofill();
          rocAddrRenderHint(false);
        })
        .catch(function () {  });
    }

    rocAddrMaybeLoad();

    function rehydrateLive() {
      var t = readLive();
      if (!t) return;
      if (t.idempotencyKey) state.idempotencyKey = String(t.idempotencyKey);
      state.submitting = true;
      var seed = ( typeof t.expires_at_ms === 'number' )
        ? Math.max(0, Math.round((t.expires_at_ms - Date.now()) / 1000))
        : undefined;
      showLiveWaitingModal(t.token, t.endpoint, t.order_number, seed);
    }
    rehydrateLive();

    window.addEventListener('beforeunload', function (e) {
      if (liveFinished || !readLive()) return;
      e.preventDefault();
      e.returnValue = '';
    });
  }

  if (typeof window !== 'undefined') {
    window.ROCFrontendTime = {
      getZonedDate: getZonedDate,
      getZonedParts: getZonedParts,
      addDaysToDateStr: addDaysToDateStr,
      slotBookable: slotBookable,
      bookableSlotMinutes: bookableSlotMinutes,
      nextBookableSlot: nextBookableSlot,
      nextOpenMoment: nextOpenMoment
    };
  }

  if (typeof document !== 'undefined' && document.addEventListener) {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-roc-instance]').forEach(function (root) {

        if (root.getAttribute('data-roc-ready') === '1') return;
        var id = root.getAttribute('data-roc-instance');
        var data = (window.ROC_DATA && window.ROC_DATA[id]) || (window.ICTBB_DATA && window.ICTBB_DATA[id]);
        if (data) {
          root.setAttribute('data-roc-ready', '1');
          render(root, data);
        }
      });
    });
  }

  function rocDiscountRawAmount(rule, basis, qty) {
    basis = basis | 0;
    if (basis <= 0) return 0;
    var type = rule.discountType;
    if (type === 'percent') return Math.floor((basis * (rule.valueBps | 0) + 5000) / 10000);
    if (type === 'fixed') return rule.valueCents | 0;
    if (type === 'fixed_per_item') return (rule.valueCents | 0) * Math.max(0, qty | 0);
    return 0;
  }

  function rocDiscountCap(amount, cap) {
    cap = cap | 0;
    return (cap > 0 && amount > cap) ? cap : amount;
  }

  function rocDiscountLineMatches(rule, line) {
    if (rule.scope === 'product') {
      return (rule.targetProductIds || []).indexOf(line.id | 0) !== -1;
    }
    if (rule.scope === 'category') {
      var cats = line.categoryIds || [];
      var targets = rule.targetCategoryIds || [];
      for (var i = 0; i < cats.length; i++) {
        if (targets.indexOf(cats[i] | 0) !== -1) return true;
      }
      return false;
    }
    return false;
  }

  function rocDiscountPreview(lines, context, rules) {
    lines = Array.isArray(lines) ? lines : [];
    rules = Array.isArray(rules) ? rules : [];
    var type = (context && context.type) || 'pickup';
    var deliveryCents = (context && context.deliveryCents) ? (context.deliveryCents | 0) : 0;

    var goodsSubtotal = 0;
    var work = lines.map(function (l) {
      var cur = (l.unitPriceCents | 0) * (l.qty | 0);
      goodsSubtotal += cur;
      return { current: cur, qty: l.qty | 0, id: l.id | 0, categoryIds: l.categoryIds || [] };
    });

    var goodsMap = {};
    function addGoods(rule, amount) {
      if (amount <= 0) return;
      var key = String(rule.ruleId);
      if (!goodsMap[key]) goodsMap[key] = { ruleId: rule.ruleId | 0, label: rule.label || '', i18n: rule.i18n, scope: rule.scope, amountCents: 0 };
      goodsMap[key].amountCents += amount;
    }

    work.forEach(function (w) {
      var best = 0, bestRule = null;
      rules.forEach(function (rule) {
        if (rule.scope !== 'product' && rule.scope !== 'category') return;
        if (!rocDiscountLineMatches(rule, w)) return;
        var amt = rocDiscountRawAmount(rule, w.current, w.qty);
        amt = rocDiscountCap(amt, rule.maxDiscountCents);
        if (amt > w.current) amt = w.current;
        if (amt > best) { best = amt; bestRule = rule; }
      });
      if (bestRule && best > 0) {
        w.current -= best;
        addGoods(bestRule, best);
      }
    });

    var goodsBasis = work.reduce(function (s, w) { return s + w.current; }, 0);
    var missing = 0;
    ['cart', 'service_type'].forEach(function (scope) {
      rules.forEach(function (rule) {
        if (rule.scope !== scope) return;
        if (scope === 'service_type' && rule.serviceType !== '' && rule.serviceType !== type) return;
        if (scope === 'cart' && goodsBasis < (rule.minSubtotalCents | 0)) {
          var short = (rule.minSubtotalCents | 0) - goodsBasis;
          if (short > 0 && (missing === 0 || short < missing)) missing = short;
          return;
        }
        if (goodsBasis <= 0) return;
        var amt = rocDiscountRawAmount(rule, goodsBasis, 0);
        amt = rocDiscountCap(amt, rule.maxDiscountCents);
        if (amt > goodsBasis) amt = goodsBasis;
        if (amt <= 0) return;
        goodsBasis -= amt;
        addGoods(rule, amt);
      });
    });

    var deliveryRows = [];
    var deliveryDiscount = 0;
    rules.forEach(function (rule) {
      if (rule.scope !== 'free_delivery' && rule.scope !== 'delivery_fee') return;
      if (rule.serviceType !== '' && rule.serviceType !== type) return;
      var remaining = deliveryCents - deliveryDiscount;
      if (remaining <= 0) return;
      var amt;
      if (rule.discountType === 'free_delivery') {
        amt = remaining;
      } else {
        amt = rocDiscountRawAmount(rule, deliveryCents, 0);
        amt = rocDiscountCap(amt, rule.maxDiscountCents);
      }
      if (amt > remaining) amt = remaining;
      if (amt <= 0) return;
      deliveryDiscount += amt;
      deliveryRows.push({ ruleId: rule.ruleId | 0, label: rule.label || '', i18n: rule.i18n, scope: rule.scope, amountCents: amt });
    });

    var goodsRows = Object.keys(goodsMap).map(function (k) { return goodsMap[k]; });
    var totalDiscount = goodsRows.reduce(function (s, r) { return s + r.amountCents; }, 0);
    var effectiveDelivery = (type === 'delivery') ? Math.max(0, deliveryCents - deliveryDiscount) : 0;
    var finalTotal = Math.max(0, goodsSubtotal - totalDiscount) + effectiveDelivery;

    return {
      goodsRows: goodsRows,
      deliveryRows: deliveryRows,
      totalDiscountCents: totalDiscount,
      deliveryDiscountCents: deliveryDiscount,
      finalTotalCents: finalTotal,
      missingCartDiscountCents: missing
    };
  }

  function rocDiscountBadgesForItem(item, rules) {
    rules = Array.isArray(rules) ? rules : [];
    var line = { id: item.id | 0, categoryIds: item.categoryIds || [] };
    var out = [];
    rules.forEach(function (rule) {
      if (rule.scope !== 'product' && rule.scope !== 'category') return;
      if (rocDiscountLineMatches(rule, line)) out.push(rule);
    });
    return out;
  }

  function rocDiscountDisplayAllowed(data) {
    if (!data) return false;
    var order = data.order || null;
    if (!order || !order.endpoint) return false;
    var rules = data.discounts;
    return Array.isArray(rules) && rules.length > 0;
  }

  function rocStepSequence(type) {
    return (type === 'pickup')
      ? ['service', 'time', 'contact', 'review']
      : ['service', 'address', 'time', 'contact', 'review'];
  }

  function rocStepAdvance(current, type) {
    var seq = rocStepSequence(type);
    var i = seq.indexOf(current);
    if (i === -1) return seq[0];
    return (i < seq.length - 1) ? seq[i + 1] : current;
  }

  function rocStepBack(current, type) {
    var seq = rocStepSequence(type);
    var i = seq.indexOf(current);
    if (i <= 0) return seq[0];
    return seq[i - 1];
  }

  function rocStepReachable(target, completed, type) {
    var seq = rocStepSequence(type);
    if (seq.indexOf(target) === -1) return false;
    completed = completed || [];
    if (completed.indexOf(target) !== -1) return true;
    for (var i = 0; i < seq.length; i++) {
      if (completed.indexOf(seq[i]) === -1) return seq[i] === target;
    }
    return true;
  }

  function rocStepForError(errorKey) {
    switch (errorKey) {

      case 'type':
      case 'requireType':
      case 'deliveryNotBookable':
      case 'pickupNotBookable':
      case 'noOrderType':
      case 'dateClosed':
      case 'deliveryDayUnavailable':
      case 'pickupDayUnavailable':
        return 'service';

      case 'address':
      case 'requireAddress':
      case 'invalidZip':
      case 'addressNotFound':
      case 'addressNumberRequired':
      case 'addressNumberUnknown':
      case 'addressUnverifiable':
      case 'noDeliveryZone':
      case 'minNotReached':
        return 'address';

      case 'slot':
      case 'requireSlot':
      case 'slotPast':
      case 'slotLead':
      case 'slotUnavailable':
      case 'slotDeliveryUnavailable':
      case 'slotPickupUnavailable':
        return 'time';

      case 'contact':
      case 'requireContact':
      case 'invalidPhone':
      case 'email':
      case 'requireEmail':
        return 'contact';

      case 'cart':
      case 'selectItem':
      case 'modifierInvalid':
      case 'captcha':
      case 'captchaFailed':
      case 'payment':
      case 'requirePayment':
        return 'review';
      default:
        return 'review';
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      specialDayMode: specialDayMode,
      specialDayNote: specialDayNote,
      serviceAllowedOnDate: serviceAllowedOnDate,
      calendarDayState: calendarDayState,
      validationError: validationError,
      normalizeClientLocale: rocNormalizeClientLocale,
      resolveCustomerLocale: rocResolveCustomerLocale,
      calendarLocale: rocCalendarLocale,
      addrNormalizeStreet: rocAddrNormalizeStreet,
      addrParseHouseNumber: rocAddrParseHouseNumber,
      addrNumberMatches: rocAddrNumberMatches,
      addrCityMatches: rocAddrCityMatches,
      addrBestStreet: rocAddrBestStreet,
      addrMatch: rocAddrMatch,
      addrNormVariants: rocAddrNormVariants,
      discountRawAmount: rocDiscountRawAmount,
      discountCap: rocDiscountCap,
      discountLineMatches: rocDiscountLineMatches,
      discountPreview: rocDiscountPreview,
      discountLabel: discountLabel,
      discountBadgesForItem: rocDiscountBadgesForItem,
      discountDisplayAllowed: rocDiscountDisplayAllowed,
      deliveryFeedback: rocDeliveryFeedback,
      stepSequence: rocStepSequence,
      stepAdvance: rocStepAdvance,
      stepBack: rocStepBack,
      stepReachable: rocStepReachable,
      stepForError: rocStepForError,
      checkService: rocCheckService,
      checkContact: rocCheckContact,
      checkDeliveryPhone: rocCheckDeliveryPhone,
      checkAddress: rocCheckAddress,
      checkTime: rocCheckTime,
      stepGate: rocStepGate,
      stepBlockIndex: rocStepBlockIndex,
      stepReachableGated: rocStepReachableGated
    };
  }
})();
